import * as Yup from "yup";
import React from "react";
import moment from "moment";
import VolturaFatturazioneElettronica
  from "../custom-steps/VolturaFatturazioneElettronica/VolturaFatturazioneElettronica";
  import { RelationshipType, TypeHeir } from "../../../helpers/enums";
import {
  AccountHolderType,
  AreaClassification,
  CadastreType,
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  ComplexCaseType,
  DeclarationType,
  PersonSex,
  PersonType,
  TipoBollettaRecapito,
  TipologiaIntestatario,
  TipologiaUsoFornitura,
  UserRoleEnum,
} from "../../../helpers/enums";

import {
  getComuniServiti,
  getCorrectLink,
  getStandardAddressFormat, getValidationObject,
  getValidationRule,
  isRadioBoolean,
  removeDeletedLayoutFields,
  removeRequiredStep,
  TranslatedText,
} from "../../../helpers/helpers";
import { client } from "../../../App";
import { GET_CONTRACT, GET_CONTRACT_METRESERIALNUMBER } from "../../../helpers/queries";
import getMenuConfig from "../../../helpers/menuConfig";
import DigitalizzazioneDocument from "../custom-steps/custom-digitalizzazione-step/DigitalizzazioneDocument";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";

let sign = false;
const {
  pdfLinks: { casesInfoVoltura },
} = getMenuConfig();
const InfoLabel = ({ label = "Test label" }) => {
  return (
    <div className="info-label">
      <span className="gc-icon-functional-attention-2-col">
        <span className="path1"></span>
        <span className="path2"></span>
      </span>
      <p>{label}</p>
    </div>
  );
};
const PlainLabel = ({ label = "Test label" }) => {
  return (
    <div className="plain-label">
      <p>{label}</p>
    </div>
  );
};
const SimpleText = ({ text = "Test text" }) => {
  return (
    <div className="simple-text">
      <span>{text}</span>
    </div>
  );
};
const startEventDataLayer = (isSentDataLayer, setIsSentDataLayer) => {
  if (!isSentDataLayer) {
    window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Voltura, "step": "avvio" });
    setIsSentDataLayer(true);
  }
};
const handleButtonMatricolaContatoreCaseClick = (index, buttonMatricolaContatoreCase, activeStep) => {
  if (activeStep === 0) {
    if (buttonMatricolaContatoreCase) {
      if (index === 2 || index === 3) {
        return true
      }
    }
    else {
      if (index < 2 || index === 3) {
        return true
      }
    }
  }
  else {
    return true;
  }
}
let model = {
  isVolturaSubentroCase: true,
  handleButtonMatricolaContatoreCaseClick: handleButtonMatricolaContatoreCaseClick,
  formId: CaseForms.Voltura,
  formField: {
    // step 1.1
    codiceContratto: {
      name: "codiceContratto",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_contratto.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.codiceClient" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_contratto.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_contratto.error_message" />
      ),
      inactiveErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_contratto.contract_invalid" />
      ),
      type: "input",
      onBlur: startEventDataLayer,
    },
    numeroFattura: {
      name: "numeroFattura",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.numero_fattura.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.codiceFattura" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.numero_fattura.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.numero_fattura.error_message" />
      ),
      type: "input",
    },
    matricolaContatoreCaseFirstStep: {
      name: "matricolaContatoreCaseFirstStep",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.matricola_contatore.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="common.matricolaContatoreCaseFirstStep" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.matricola_Contatore_Case_First_Step.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.matricola_Contatore_Case_First_Step.error_message" />
      ),
      type: "input",
      onBlur: startEventDataLayer,
    },
    volturaMortisCausa: {
      name: "volturaMortisCausa",
      label: <TranslatedText i18nKey="cases.voltura.fields.mortis_causa.checkbox_label" />,
      type: "checkbox",
      volturaMortisCausaCheckbox: false,
      onInitialize: (field) => {
        if(field != undefined){
          volturaMortisCausa.volturaMortisCausaCheckbox = field;
        }
      }
    },
    // step 1.2
    comune: {
      name: "comune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    via: {
      name: "via",
      label: <TranslatedText i18nKey="cases.request_info.fields.via.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.via.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    codicePrecedenteUtente: {
      name: "codicePrecedenteUtente",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_precedente_utente.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    matricolaContatore: {
      name: "matricolaContatore",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.matricola_contatore.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    // step 1.3
    tipoIntestatario: {
      name: "tipoIntestatario",
      type: "switch-radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo_intestatario.fisica.label" />
          ),
          value: PersonType.NATURAL,
          grid: { xs: 12, md: "auto" },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo_intestatario.giuridica.label" />
          ),
          value: PersonType.LEGAL,
          grid: { xs: 12, md: 8 },
        },
      ],
      onSelected: (selected, values, profile, setFieldValue) => {
        setFieldValue(signValue.name, sign);
        if (profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
          let piva = "";
          let fiscalCode = "";
          if (profile.fiscalCode !== "") {
            if (isNaN(Number(profile.fiscalCode))) {
              fiscalCode = profile.fiscalCode;
            } else {
              piva = profile.fiscalCode;
            }
          }
          if (selected === PersonType.NATURAL) {
            values[fisicaNome.name] === "" &&
              setFieldValue(fisicaNome.name, profile.name || "");
            values[fisicaCognome.name] === "" &&
              setFieldValue(fisicaCognome.name, profile.surname || "");
            values[fisicaCodiceFiscale.name] === "" &&
              setFieldValue(fisicaCodiceFiscale.name, fiscalCode || "");
          }
          if (selected === PersonType.LEGAL) {
            values[giuridicaRagioneSociale.name] === "" &&
              setFieldValue(
                giuridicaRagioneSociale.name,
                profile.businessName || ""
              );
            values[giuridicaCodiceFiscale.name] === "" &&
              setFieldValue(giuridicaCodiceFiscale.name, fiscalCode || "");
            values[giuridicaPartitaIVA.name] === "" &&
              setFieldValue(giuridicaPartitaIVA.name, piva || "");
            values[giuridicaPartitaIVA2.name] === "" &&
              setFieldValue(giuridicaPartitaIVA2.name, piva || "");
            values[giuridicaNome.name] === "" &&
              setFieldValue(giuridicaNome.name, profile.name || "");
            values[giuridicaCognome.name] === "" &&
              setFieldValue(giuridicaCognome.name, profile.surname || "");
            values[giuridicaSedeLegaleComune.name] === "" &&
              setFieldValue(
                giuridicaSedeLegaleComune.name,
                profile.legalAddress_city || ""
              );
            values[giuridicaProvincia.name] === "" &&
              setFieldValue(
                giuridicaProvincia.name,
                profile.legalAddress_province || ""
              );
            values[giuridicaCAP.name] === "" &&
              setFieldValue(
                giuridicaCAP.name,
                profile.legalAddress_postalCode || ""
              );
            values[giuridicaIndirizzo.name] === "" &&
              setFieldValue(
                giuridicaIndirizzo.name,
                profile.legalAddress_street
                  ? `${profile.legalAddress_street}, ${profile.legalAddress_streetNumber}`
                  : ""
              );
          }
          values[bollettaCellulare.name] === "" &&
            setFieldValue(bollettaCellulare.name, profile.mobilePhoneNumber);
          values[bollettaFisso.name] === "" &&
            setFieldValue(bollettaFisso.name, profile.landlinePhoneNumber);
          values[bollettaEmail.name] === "" &&
            setFieldValue(bollettaEmail.name, profile.email);
          values[bollettaPec.name] === "" &&
            setFieldValue(bollettaPec.name, profile.pec);
          values[bollettaPuntoDiFurnitura.name] === "" &&
            setFieldValue(
              bollettaPuntoDiFurnitura.name,
              getStandardAddressFormat(
                "cases.address_suggestion.button_1",
                values.comune,
                values.via
              )
            );
        }
      },
      stepToExclude : ()=>{
        if(volturaMortisCausa.volturaMortisCausaCheckbox){
          return [PersonType.LEGAL];
        }
        else return [];
      }
    },
    // Natural Person
    fisicaNome: {
      name: "fisicaNome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.fisica_nome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.fisica_nome.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaCognome: {
      name: "fisicaCognome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.fisica_cognome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.fisica_cognome.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaCodiceFiscale: {
      name: "fisicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.match" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "input",
      uppercase: true,
    },
    fisicaNatoA: {
      name: "fisicaNatoA",
      label: <TranslatedText i18nKey="cases.voltura.fields.nato_a.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaDataNascita: {
      name: "fisicaDataNascita",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.data_nascita.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
    },
    fisicaSesso: {
      name: "fisicaSesso",
      label: <TranslatedText i18nKey="cases.voltura.fields.sesso.label" />,
      type: "radio",
      options: [
        { label: "M", value: PersonSex.M, grid: { xs: 6, md: "auto" } },
        {
          label: "F",
          value: PersonSex.F,
          grid: { xs: 6, md: 3 },
        },
      ],
    },
    fisicaVia: {
      name: "fisicaVia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaIndirizzoResidenza.required.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "egon-address",
      suggestionType: "address",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.fisicaVia.required" />
      ),
      onError: (value, setFieldValue) => {
        setFieldValue(fisicaVia.name, value)
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(fisicaVia.name, value);
        setFieldValue(fisicaComuneResidenza.name, "");
        setFieldValue(fisicaCAP.name, "");
        setFieldValue(fisicaProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(fisicaVia.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(fisicaComuneResidenza.name, components.comune || "");
        setFieldValue(fisicaCAP.name, components.cap || "");
        setFieldValue(fisicaProvincia.name, components.provincia || "");
        egonCodeResponse.tipo_Indirizzo="residenza";
        fisicaVia.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    fisicaComuneResidenza: {
      name: "fisicaComuneResidenza",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.comune_residenza.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaProvincia: {
      name: "fisicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaCAP: {
      name: "fisicaCAP",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.cap.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "input",
    },
    // Legal Person
    giuridicaRagioneSociale: {
      name: "giuridicaRagioneSociale",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.ragione_sociale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
    },
    giuridicaCodiceFiscale: {
      name: "giuridicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.voltura.field.codice_fiscale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.match" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      uppercase: true,
    },
    giuridicaPartitaIVA: {
      name: "giuridicaPartitaIVA",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.partita_iva.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaPartitaIVA2: {
      name: "giuridicaPartitaIVA2",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.partita_iva.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaPartitaIVAGrupoCheckbox: {
      name: "giuridicaPartitaIVAGrupoCheckbox",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step1.2.giuridicaPartitaIVAGrupoCheckbox.label" />
      ),
      type: "checkbox",
    },
    giuridicaPartitaIVAGrupo: {
      name: "giuridicaPartitaIVAGrupo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVAGrupo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaNome: {
      name: "giuridicaNome",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleName.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaCognome: {
      name: "giuridicaCognome",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleSurname.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaIndirizzo: {
      name: "giuridicaIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.sede_legale_indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(giuridicaIndirizzo.name, value);
        giuridicaSedeLegaleComune.readonly = false;
        giuridicaCAP.readonly = false;
        giuridicaProvincia.readonly = false;
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(giuridicaIndirizzo.name, value);
        setFieldValue(giuridicaSedeLegaleComune.name, "");
        setFieldValue(giuridicaCAP.name, "");
        setFieldValue(giuridicaProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(giuridicaIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        if (components.comune) {
          setFieldValue(giuridicaSedeLegaleComune.name, components.comune);
          giuridicaSedeLegaleComune.readonly = true;
        } else {
          setFieldValue(giuridicaSedeLegaleComune.name, "");
          giuridicaSedeLegaleComune.readonly = false;
        }

        if (components.cap) {
          setFieldValue(giuridicaCAP.name, components.cap);
          giuridicaCAP.readonly = true;
        } else {
          setFieldValue(giuridicaCAP.name, "");
          giuridicaCAP.readonly = false;
        }

        if (components.provincia) {
          setFieldValue(giuridicaProvincia.name, components.provincia);
          giuridicaProvincia.readonly = true;
        } else {
          setFieldValue(giuridicaProvincia.name, "");
          giuridicaProvincia.readonly = false;
        }
        egonCodeResponse.tipo_Indirizzo="residenza";
        giuridicaIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    giuridicaSedeLegaleComune: {
      name: "giuridicaSedeLegaleComune",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.sede_legale_comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    giuridicaProvincia: {
      name: "giuridicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    giuridicaCAP: {
      name: "giuridicaCAP",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.cap.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "input",
      readonly: true,
    },
    // step 2.1
    codiceDestinatarioPA: {
      name: "codiceDestinatarioPA",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.destinario_pa.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    userRole: {
      name: "userRole",
      type: "input",
    },
    indirizzoPEC: {
      name: "indirizzoPEC",
      label: <TranslatedText i18nKey="cases.voltura.fields.email_pec.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.email_pec.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />
      ),
      type: "input",
    },
    codiceCIG: {
      name: "codiceCIG",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.person_type.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    codiceCUP: {
      name: "codiceCUP",
      label: <TranslatedText i18nKey="cases.voltura.fields.cup_code.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    splitPaymentCat: {
      name: "splitPaymentCat",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.split_payment_cat.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    codiceDestinatarioSDI: {
      name: "codiceDestinatarioSDI",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.destinario_sdi.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    // step 3.1
    signValue: {
      name: "signValue",
      label: <TranslatedText i18nKey="cases.request_info.fields.sign.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaRecapitoTipo: {
      name: "bollettaRecapitoTipo",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.bolletta_racapito_tipo.label" />
          ),
          value: TipoBollettaRecapito.PRE_ESISTENTE,
          grid: { xs: 12 },
        },
      ],
    },
    bollettaRecapitoNuovoIndirizzo: {
      name: "bollettaRecapitoTipo",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      summaryView: false,
      onChange: (selected, values, setFieldValue) => {
        setFieldValue(bollettaIndirizzo.name, "");
        setFieldValue(bollettaComune.name, "");
        setFieldValue(bollettaCap.name, "");
        setFieldValue(bollettaProvincia.name, "");
      },
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.bolletta_racapito_nuovo.label" />
          ),
          value: TipoBollettaRecapito.NUOVO,
          grid: { xs: 12 },
        },
      ],
    },
    bollettaPuntoDiFurnitura: {
      name: "bollettaPuntoDiFurnitura",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "button",
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaDatiIntestatario.name)
          .classList.remove("selected");
        const egonOrder = bollettaIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        inputs[0].value = values.via;
        setFieldValue(bollettaIndirizzo.name, values.via);
        setFieldValue(bollettaComune.name, values.comune);
        setFieldValue(bollettaCap.name, "");
        setFieldValue(bollettaProvincia.name, "");
      },
    },
    bollettaDatiIntestatario: {
      name: "bollettaDatiIntestatario",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "button",
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaPuntoDiFurnitura.name)
          .classList.remove("selected");
        const egonOrder = bollettaIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        const value = values.tipoIntestatario === PersonType.NATURAL ? values.fisicaVia : values.giuridicaIndirizzo;
        inputs[0].value = value;
        let egonCodeResponse = PersonType.NATURAL ? {...fisicaVia.egonCodeResponse} : {...giuridicaIndirizzo.egonCodeResponse};
        if(Object.keys(egonCodeResponse).length !== 0){
          egonCodeResponse.tipo_Indirizzo ="recapito";
          bollettaIndirizzo.egonCodeResponse = egonCodeResponse;
        }        
        setFieldValue(
          bollettaIndirizzo.name,
          value);
        setFieldValue(
          bollettaComune.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaComuneResidenza
            : values.giuridicaSedeLegaleComune
        );
        setFieldValue(
          bollettaProvincia.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaProvincia
            : values.giuridicaProvincia
        );
        setFieldValue(
          bollettaCap.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaCAP
            : values.giuridicaCAP
        );
      },
    },
    bollettaIndirizzo: {
      name: "bollettaIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.required.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      borderError: true,
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaIndirizzo.name, value);
        setFieldValue(bollettaComune.name, "");
        setFieldValue(bollettaCap.name, "");
        setFieldValue(bollettaProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaComune.name, components.comune || "");
        setFieldValue(bollettaCap.name, components.cap || "");
        setFieldValue(bollettaProvincia.name, components.provincia || "");
        egonCodeResponse.tipo_Indirizzo="recapito";
        bollettaIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "3",
    },
    bollettaComune: {
      name: "bollettaComune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCap: {
      name: "bollettaCap",
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "input",
    },
    bollettaProvincia: {
      name: "bollettaProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaNomePresso: {
      name: "bollettaNomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    }, bollettaCognomePresso: {
      name: "bollettaCognomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.cognome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCellulare: {
      name: "bollettaCellulare",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaFisso: {
      name: "bollettaFisso",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    bollettaEmail: {
      name: "bollettaEmail",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaConfirmEmail: {
      name: "bollettaConfirmEmail",
      label: <TranslatedText i18nKey="cases.digitalization.confirm" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaPec: {
      name: "bollettaPec",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      type: "input",
    },

    // step 4.1
    inQualitaDi: {
      name: "inQualitaDi",
      label: "",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.in_qualita_di" />
      ),
      onChange: (selected, values, setFieldValue) => {
        if (selected !== AccountHolderType.OWNER) {
          setFieldValue(ilSottoscrittoNome.name, "");
          setFieldValue(ilSottoscrittoCognome.name, "");
          setFieldValue(registeredNumber.name, "");
          setFieldValue(registeredDate.name, "");
          setFieldValue(ownerOtherInsert.name, "");
          setFieldValue(ownerStatus.name, false);
          setFieldValue(ownerOther.name, false);
        }
        if (selected !== AccountHolderType.OTHER) {
          setFieldValue(holderOther.name, "");
        }
        if (selected === AccountHolderType.OWNER) {
          setFieldValue(ownerStatus.name, true)
        }
      },
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.proprietario.label" />
          ),
          value: AccountHolderType.OWNER,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.affittuario.label" />
          ),
          value: AccountHolderType.TENANT,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.administratore.label" />
          ),
          value: AccountHolderType.CONDOMINIUM_ADMIN,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.usufruttuario.label" />
          ),
          value: AccountHolderType.USUFRUCTUARY,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.rappresentante.label" />
          ),
          value: AccountHolderType.LEGAL_REPRESENTATIVE,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.altro.label" />
          ),
          value: AccountHolderType.OTHER,
          grid: { md: "auto" },
        },
      ],
    },
    holderOther: {
      name: "holderOther",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    ilSottoscrittoNome: {
      name: "ilSottoscrittoNome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.error_message" />
      ),
      type: "input",
    },
    ilSottoscrittoCognome: {
      name: "ilSottoscrittoCognome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.error_message" />
      ),
      type: "input",
    },
    ownerStatus: {
      name: "ownerStatus",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.checkbox.owner_status.label" />
      ),
      type: "checkbox",
    },
    lettura: {
      name: "lettura",
      label: <TranslatedText i18nKey="cases.voltura.fields.lettura.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    registeredNumber: {
      name: "registeredNumber",
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.registered_number.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      type: "input",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
      ),
    },
    registeredDate: {
      name: "registeredDate",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
      ),
    },
    presaIdrica: {
      name: "presaIdrica",
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.exclusive_use.yes.label" />
          ),
          value: "true",
          grid: { xs: "auto" },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.exclusive_use.no.label" />
          ),
          value: "false",
          grid: { xs: 6 },
        },
      ],
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.step_4.presa_idrica" />
      ),
    },
    letturaPossessoImmobile: {
      name: "letturaPossessoImmobile",
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.registered_number.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.lettura_possesso_immobile.step4_1" />
      ),
      type: "input",
    },
    dataPossessoImmobile: {
      name: "dataPossessoImmobile",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.data_possesso_immobile.step4_1" />
      ),
      type: "date",
    },
    ownerOther: {
      name: "ownerOther",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.checkbox.owner_other.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "checkbox",
    },
    ownerOtherInsert: {
      name: "ownerOtherInsert",
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step4_2.other.placeholder" />
      ),
      type: "input",
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.fields.checkbox.owner_other.label" />
      ),
    },
    dataDecorrenza: {
      name: "dataDecorrenza",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.data_decorrenza.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
    },
    letturaDecorrenza: {
      name: "letturaDecorrenza",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.lettura_decorrenza.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      type: "input",
    },
    // voltura Mortis Causa
    inQualitaDiMortisCausa: {
      name: "inQualitaDiMortisCausa",
      label: "",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      summaryLabel: (
        <TranslatedText i18nKey="cases.allacciamento.in_qualita_di" />
      ),
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.proprietario.label" />
          ),
          value: AccountHolderType.OWNER,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.affittuario.label" />
          ),
          value: AccountHolderType.TENANT,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.usufruttuario.label" />
          ),
          value: AccountHolderType.USUFRUCTUARY,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.in_qualita_di.altro.label" />
          ),
          value: AccountHolderType.OTHER,
          grid: { md: "auto" },
        },
      ],
    },
    ilSottoscrittoNomeMortisCausa: {
      name: "ilSottoscrittoNomeMortisCausa",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.error_message" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.placeholder" />
      ),
      type: "input",
    },
    ilSottoscrittoCognomeMortisCausa: {
      name: "ilSottoscrittoCognomeMortisCausa",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.error_message" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.placeholder" />
      ),
      type: "input",
    },
    soleHeirStatusMortisCausa: {
      name: "soleHeirStatusMortisCausa",
      label:"",
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.checkbox.soleHeirStatusMortisCausa.label" />
          ),
          value: TypeHeir.SOLE,
          grid: { md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.checkbox.delegatedHeirStatusMortisCausa.label" />
          ),
          value: TypeHeir.DELEGATED,
          grid: { md: 8 },
        },
      ],
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.fields.checkbox.soleHeirStatusMortisCausa.summarylabel" />
      ),
    },
    ownerMortisCausa: {
      name: "ownerMortisCausa",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.labels.intestatario" />
      ),
      type: "input",
    },
    dateOwnerMortisCausa: {
      name: "dateOwnerMortisCausa",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.labels.deceduto" />
      ),
      type: "date",
    },
    degreeOfKinship : {
      name: "degreeOfKinship",
      label: "",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      onChange : (selected, values, setFieldValue) => {
        setFieldValue(degreeOfKinshipOther.name, "");
        if(selected===RelationshipType.OTHER){
          degreeOfKinshipOther.readonly=false;
        }
        else{
          degreeOfKinshipOther.readonly=true;
        }
      },
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.labels.inQualitaDi" />
      ),
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.request_info.fields_firstOption" />
          ),
          value: RelationshipType.SPOUSE,
        },
        {
          label: (
            <TranslatedText i18nKey="cases.request_info.fields_secondOption" />
          ),
          value: RelationshipType.SON,
        },
        {
          label: (
            <TranslatedText i18nKey="cases.request_info.fields_thirdOption" />
          ),
          value: RelationshipType.PARENT,
        },
        {
          label: (
            <TranslatedText i18nKey="cases.request_info.fields_fourthOption" />
          ),
          value: RelationshipType.OTHER,
        },
      ],
    },
    degreeOfKinshipOther: {
      name: "degreeOfKinshipOther",
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      readonly: true,
      type: "input",
    },
    supplyContractMortisCausa: {
      name: "supplyContractMortisCausa",
      label: (
        <TranslatedText i18nKey="cases.request_info.supplyContractMortisCausa" />
         ),
      type: "checkbox",
    },
    cityMortisCausa: {
      name: "cityMortisCausa",
      label: (
       <TranslatedText i18nKey="cases.request_info.fields.voltura.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.fields.voltura.comune.label" />
      ),
      type: "input",
      readonly:true,
    },
    streetMortisCausa: {
      name: "streetMortisCausa",
      label: (
        <TranslatedText i18nKey="cases.request_info.streetMortisCausa" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.streetMortisCausa" />
      ),
      type: "input",
      readonly:true,
    },
    dateLastMeterReadingMortisCausa: {
      name: "dateLastMeterReadingMortisCausa",
      label : (
      <TranslatedText i18nKey="cases.request_info.dateLastMeterReadingMortisCausa" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />
      ),
      summaryLabel: (
       <TranslatedText i18nKey="cases.request_info.dateLastMeterReadingMortisCausa" />
      ),
      type: "date",
    },
   valueMeterReadingMortisCausa: {
      name: "valueMeterReadingMortisCausa",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields_valueMeterReadingMortisCausa" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.fields_valueMeterReadingMortisCausa" />
       ),
      type: "input",
    },
    // step 4.2
    codiceUtente: {
      name: "codiceUtente",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.codiceUtente.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.inserisci" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codiceUtente.error_message" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    nomeCognome: {
      name: "nomeCognome",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.nomeCognome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.nomeCognome.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    letturaFinale: {
      name: "letturaFinale",
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.inserisci" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    recapitoBolletta: {
      name: "recapitoBolletta",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.recapito_bolletta.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.recapito_bolletta.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },

    // step 4.3
    tipo: {
      name: "tipo",
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo.fabbricati.label" />
          ),
          value: CadastreType.MANUFACTURED,
          grid: { xs: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo.immobile.label" />
          ),
          value: CadastreType.PROPERTY_NOT_STACKED,
          grid: { xs: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo.agricoli.label" />
          ),
          value: CadastreType.AGRICULTURAL_LAND,
          grid: { xs: 12, md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.fields.tipo.non_accatastabile.label" />
          ),
          value: CadastreType.NON_STACKABLE_PROPERTY,
          grid: { xs: 12, md: 3 },
        },
      ],
    },
    datiCatastaliComuneAmministrativo: {
      name: "datiCatastaliComuneAmministrativo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.comune_administrativo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "input",
      readonly: true,
    },
    datiCatastaliProvincia: {
      name: "datiCatastaliProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.provincia.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiCatastaliComuneCatastale: {
      name: "datiCatastaliComuneCatastale",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.comune_catastale.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.comune_catastale.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "suggestions",
      message: true,

      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        if (selected) {
          setFieldValue("datiCatastaliProvinciaCatastale", selected.provincia);
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
      },
    },
    datiCatastaliProvinciaCatastale: {
      name: "datiCatastaliProvinciaCatastale",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.provincia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.provincia.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiCatastaliIndirizzo: {
      name: "datiCatastaliIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiCatastaliNumeroCivico: {
      name: "datiCatastaliNumeroCivico",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.numero_civico.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    datiCatastaliEdificio: {
      name: "datiCatastaliEdificio",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.edificio.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliScala: {
      name: "datiCatastaliScala",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.scala.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliPiano: {
      name: "datiCatastaliPiano",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.piano.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliAppartamento: {
      name: "datiCatastaliAppartamento",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.appartamento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliCodiceComuneCatastale: {
      name: "datiCatastaliCodiceComuneCatastale",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.comune.codice.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliSezioneUrbana: {
      name: "datiCatastaliSezioneUrbana",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.seziona_urbana.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliComuneFoglio: {
      name: "datiCatastaliComuneFoglio",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.comune.foglio.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliParticella: {
      name: "datiCatastaliParticella",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.particella.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    datiCatastaliSubalterno: {
      name: "datiCatastaliSubalterno",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.catastali.subalterno.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    // step 5.1
    tipologiaUso: {
      name: "tipologiaUso",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      summaryView: false,
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domenistico.label" />
          ),
          value: TipologiaUsoFornitura.DOMESTICO,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domenistico.label" />
          ),
          value: TipologiaUsoFornitura.NON_DOMESTICO,
          grid: { md: 4 },
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected !== TipologiaUsoFornitura.NON_DOMESTICO) {
          setFieldValue(tipologiaUsoNonDomestica.name, 'AreaClassification.INDUSTRIAL_USE');
        }
      },
      stepToExclude : ()=>{
        if(volturaMortisCausa.volturaMortisCausaCheckbox){
          return [TipologiaUsoFornitura.NON_DOMESTICO];
        }
        else return [];
      }
    },
    tipologiaUsoDomestica: {
      name: "tipologiaUsoDomestica",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.residente.label" />
          ),
          value: AreaClassification.RESIDENT_DOMESTIC_USE,
          grid: { xs: 12, md: 6 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.non_residente.label" />
          ),
          value: AreaClassification.NOT_RESIDENT_DOMESTIC_USE,
          grid: { xs: 12, md: 6 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.condominiale.label" />
          ),
          value: AreaClassification.CONDOMINIUM_USE,
          grid: { xs: 12, md: 6 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.altro.label" />
          ),
          value: AreaClassification.OTHER_USE,
          grid: { xs: 12, md: 6 },
        },
      ],
      stepToExclude : ()=>{
        if(!volturaMortisCausa.volturaMortisCausaCheckbox){
          return [AreaClassification.OTHER_USE];
        }
        else return [];
      }
    },
    case_2: {
      name: "case_2",
      label: <TranslatedText i18nKey="cases.sottotipo" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_4.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ISTITUTI_SCOLASTICI" />,
          value: "ISTITUTI_SCOLASTICI",
        },
        {
          label: (
            <TranslatedText i18nKey="PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA" />
          ),
          value: "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA",
        },
        {
          label: <TranslatedText i18nKey="CASE_DI_CURA_E_DI_ASSISTENZA" />,
          value: "CASE_DI_CURA_E_DI_ASSISTENZA",
        },
        {
          label: <TranslatedText i18nKey="OSPEDALI_E_STRUTTURE_OSPEDALIERE" />,
          value: "OSPEDALI_E_STRUTTURE_OSPEDALIERE",
        },
        {
          label: <TranslatedText i18nKey="PRESE_ANTINCENDIO" />,
          value: "PRESE_ANTINCENDIO",
        },
        {
          label: <TranslatedText i18nKey="ALTRO" />,
          value: "ALTRO",
        },
        {
          label: <TranslatedText i18nKey="CARCERI" />,
          value: "CARCERI",
        },
      ],

    },

    case_2_1: {
      name: "case_2_1",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      onChange: (selected, values, setFieldValue) => {
        console.log('hello')
        if (selected) {
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA" />,
          value: "SCUOLA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_INFANZIA" />,
          value: "SCUOLA_INFANZIA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_PRIMARIA" />,
          value: "SCUOLA_PRIMARIA",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_SECONDARIA_I_grado" />,
          value: "SCUOLA_SECONDARIA_I_grado",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_SECONDARIA_II_grado" />,
          value: "SCUOLA_SECONDARIA_II_grado",
        },
        {
          label: <TranslatedText i18nKey="SCUOLA_PALESTRA" />,
          value: "SCUOLA_PALESTRA",
        },
        {
          label: <TranslatedText i18nKey="UNIVERSITA" />,
          value: "UNIVERSITA",
        },
      ],
    },

    case_2_2: {
      name: "case_2_2",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_AEREONAUTICA" />,
          value: "CASERMA_AEREONAUTICA",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_CARABINIERI" />,
          value: "CASERMA_CARABINIERI",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_GUARDIA_FINANZA" />,
          value: "CASERMA_GUARDIA_FINANZA",
        },
        {
          label: <TranslatedText i18nKey="CASERMA_VIGILI_DEL_FUOCO" />,
          value: "CASERMA_VIGILI_DEL_FUOCO",
        },
        {
          label: <TranslatedText i18nKey="POLIZIA_LOCALE" />,
          value: "POLIZIA_LOCALE",
        },
        {
          label: <TranslatedText i18nKey="PRETURA" />,
          value: "PRETURA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_PROTEZIONE_CIVILE" />,
          value: "CENTRO_PROTEZIONE_CIVILE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_2_3: {
      name: "case_2_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AMBULATORIO_COMUNALE" />,
          value: "AMBULATORIO_COMUNALE",
        },
        {
          label: <TranslatedText i18nKey="CASA_DI_CURA" />,
          value: "CASA_DI_CURA",
        },
        {
          label: <TranslatedText i18nKey="CASA_DI_RIPOSO" />,
          value: "CASA_DI_RIPOSO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_2_4: {
      name: "case_2_4",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_SANITARIA" />,
          value: "AZIENDA_SANITARIA",
        },
        {
          label: <TranslatedText i18nKey="OSPEDALE" />,
          value: "OSPEDALE",
        },
        {
          label: <TranslatedText i18nKey="CROCE_ROSSA_CROCE_BIANCA" />,
          value: "CROCE_ROSSA_CROCE_BIANCA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_3: {
      name: "case_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="PRESA_ANTINCENDIO_CON_CONTATORE" />,
          value: "PRESA_ANTINCENDIO_CON_CONTATORE",
        },
        {
          label: <TranslatedText i18nKey="PRESA_ANTINCENDIO_SENZA_CONTATORE" />,
          value: "PRESA_ANTINCENDIO_SENZA_CONTATORE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_3_1: {
      name: "case_3_1",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="AREA_ATTREZZATA_CANI" />,
          value: "AREA_ATTREZZATA_CANI",
        },
        {
          label: <TranslatedText i18nKey="AREA_MANIFESTAZIONI" />,
          value: "AREA_MANIFESTAZIONI",
        },
        {
          label: <TranslatedText i18nKey="AREA_MERCATO" />,
          value: "AREA_MERCATO",
        },
        {
          label: <TranslatedText i18nKey="AREA_PARCHEGGI" />,
          value: "AREA_PARCHEGGI",
        },
        {
          label: <TranslatedText i18nKey="AREA_PUBBLICA" />,
          value: "AREA_PUBBLICA",
        },
        {
          label: <TranslatedText i18nKey="AUDITORIUM" />,
          value: "AUDITORIUM",
        },
        {
          label: <TranslatedText i18nKey="BAGNI_PUBBLICI" />,
          value: "BAGNI_PUBBLICI",
        },
        {
          label: <TranslatedText i18nKey="BIBLIOTECA" />,
          value: "BIBLIOTECA",
        },
        {
          label: <TranslatedText i18nKey="CABINA_ELETTRICA_GAS_METANO" />,
          value: "CABINA_ELETTRICA_GAS_METANO",
        },
        {
          label: <TranslatedText i18nKey="CAMPO_NOMADI" />,
          value: "CAMPO_NOMADI",
        },
        {
          label: <TranslatedText i18nKey="CENTRALE_TERMICA" />,
          value: "CENTRALE_TERMICA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_ANZIANI" />,
          value: "CENTRO_ANZIANI",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_CIVICO" />,
          value: "CENTRO_CIVICO",
        },
        {
          label: <TranslatedText i18nKey="CIMITERO" />,
          value: "CIMITERO",
        },
        {
          label: <TranslatedText i18nKey="CINEMA_TEATRO" />,
          value: "CINEMA_TEATRO",
        },
        {
          label: <TranslatedText i18nKey="DEPOSITO_BICICLETTE" />,
          value: "DEPOSITO_BICICLETTE",
        },
        {
          label: <TranslatedText i18nKey="ECOCENTRO" />,
          value: "ECOCENTRO",
        },
        {
          label: <TranslatedText i18nKey="EDIFICI_COMUNALI" />,
          value: "EDIFICI_COMUNALI",
        },
        {
          label: <TranslatedText i18nKey="ENTE_PUBBLICO" />,
          value: "ENTE_PUBBLICO",
        },
        {
          label: <TranslatedText i18nKey="IMPIANTO_SPORTIVO" />,
          value: "IMPIANTO_SPORTIVO",
        },
        {
          label: <TranslatedText i18nKey="IMPIANTO_SPORTIVO_PISCINA" />,
          value: "IMPIANTO_SPORTIVO_PISCINA",
        },
        {
          label: <TranslatedText i18nKey="MAGAZZINO_COMUNALE" />,
          value: "MAGAZZINO_COMUNALE",
        },

        {
          label: <TranslatedText i18nKey="MENSA" />,
          value: "MENSA",
        },

        {
          label: <TranslatedText i18nKey="MUSEO" />,
          value: "MUSEO",
        },

        {
          label: <TranslatedText i18nKey="PULIZIA_STRADE" />,
          value: "PULIZIA_STRADE",
        },
        {
          label: <TranslatedText i18nKey="SEDE_COMUNALE" />,
          value: "SEDE_COMUNALE",
        },
      ],
    },
    case_4: {
      name: "case_4",
      label: <TranslatedText i18nKey="cases.sottotipo" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="USO_DIVERSO" />,
          value: "USO_DIVERSO",
        },
        {
          label: (
            <TranslatedText i18nKey="USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE" />
          ),
          value: "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
        },
        {
          label: <TranslatedText i18nKey="USO_IRRIGUO_E_COLLETTIVO" />,
          value: "USO_IRRIGUO_E_COLLETTIVO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2.name, "")
        }
      },
    },
    case_4_1: {
      name: "case_4_1",
      label: "Tipo Uso",
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="CONDOMINIALE" />,
          value: "CONDOMINIALE",
        },
        {
          label: <TranslatedText i18nKey="PRIVATO" />,
          value: "PRIVATO",
        },
        {
          label: <TranslatedText i18nKey="CANTIERE" />,
          value: "CANTIERE",
        },
      ],

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_4_2: {
      name: "case_4_2",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ORGANIZZAZIONE_TERZO_SETTORE" />,
          value: "ORGANIZZAZIONE_TERZO_SETTORE",
        },
        {
          label: <TranslatedText i18nKey="ASSOCIAZIONE_SPORTIVA" />,
          value: "ASSOCIAZIONE_SPORTIVA",
        },
        {
          label: <TranslatedText i18nKey="CHIESA_E_LUOGO_DI_CULTO" />,
          value: "CHIESA_E_LUOGO_DI_CULTO",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_4_3: {
      name: "case_4_3",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="IRRIGAZIONE_PUBBLICA" />,
          value: "IRRIGAZIONE_PUBBLICA",
        },
        {
          label: <TranslatedText i18nKey="IRRIGAZIONE_PRIVATA" />,
          value: "IRRIGAZIONE_PRIVATA",
        },
        {
          label: <TranslatedText i18nKey="CASA_DELL_ACQUA" />,
          value: `CASA_DELL_ACQUA`,
        },
        {
          label: <TranslatedText i18nKey="FONTANELLA_PUBBLICA" />,
          value: "FONTANELLA_PUBBLICA",
        },
      ],

      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },

    case_5: {
      name: "case_5",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ALLEVAMENTO_ANIMALI" />,
          value: "ALLEVAMENTO_ANIMALI",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_AGRICOLA" />,
          value: "AZIENDA_AGRICOLA",
        },
        {
          label: <TranslatedText i18nKey="FLORICOLTURA" />,
          value: "FLORICOLTURA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_6.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_6: {
      name: "case_6",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: <TranslatedText i18nKey="AGENZIA_ASSICURAZIONI" />,
          value: "AGENZIA_ASSICURAZIONI",
        },
        {
          label: <TranslatedText i18nKey="ALBERGHI_E_STRUTTURE_SIMILI" />,
          value: "ALBERGHI_E_STRUTTURE_SIMILI",
        },
        {
          label: <TranslatedText i18nKey="ATTIVITA_IMMOBILIARI" />,
          value: `ATTIVITA_IMMOBILIARI`,
        },
        {
          label: <TranslatedText i18nKey="AUTOFFICINA" />,
          value: "AUTOFFICINA",
        },
        {
          label: <TranslatedText i18nKey="AUTOLAVAGGIO" />,
          value: "AUTOLAVAGGIO",
        },
        {
          label: <TranslatedText i18nKey="AUTONOLEGGIO" />,
          value: "AUTONOLEGGIO",
        },
        {
          label: <TranslatedText i18nKey="AUTOSCUOLA" />,
          value: "AUTOSCUOLA",
        },
        {
          label: <TranslatedText i18nKey="AUTOTRASPORTI" />,
          value: "AUTOTRASPORTI",
        },
        {
          label: <TranslatedText i18nKey="BANCA" />,
          value: "BANCA",
        },
        {
          label: <TranslatedText i18nKey="BAR_CAFFETTERIA" />,
          value: "BAR_CAFFETTERIA",
        },
        {
          label: <TranslatedText i18nKey="CARROZZERIA" />,
          value: "CARROZZERIA",
        },
        {
          label: <TranslatedText i18nKey="CENTRO_ESTETICO_BENESSERE" />,
          value: "CENTRO_ESTETICO_BENESSERE",
        },
        {
          label: <TranslatedText i18nKey="COMMERCIO_AL_DETTAGLIO" />,
          value: "COMMERCIO_AL_DETTAGLIO",
        },
        {
          label: <TranslatedText i18nKey="CONCESSIONARIA_AUTO" />,
          value: "CONCESSIONARIA_AUTO",
        },
        {
          label: (
            <TranslatedText i18nKey="CONDOMINIO_INDUSTRIALE_COMMERCIALE" />
          ),
          value: "CONDOMINIO_INDUSTRIALE_COMMERCIALE",
        },
        {
          label: <TranslatedText i18nKey="DISTRIBUTORE_CARBURANTI" />,
          value: "DISTRIBUTORE_CARBURANTI",
        },
        {
          label: <TranslatedText i18nKey="FALEGNAMERIA" />,
          value: "FALEGNAMERIA",
        },
        {
          label: <TranslatedText i18nKey="FARMACIA_PARAFARMACIA" />,
          value: "FARMACIA_PARAFARMACIA",
        },
        {
          label: <TranslatedText i18nKey="FIORISTA" />,
          value: "FIORISTA",
        },
        {
          label: (
            <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_FERROVIARIE" />
          ),
          value: "GESTIONE_INFRASTRUTTURE_FERROVIARIE",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_STRADALI" />,
          value: "GESTIONE_INFRASTRUTTURE_STRADALI",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_INFRASTRUTTURE_STRADALI" />,
          value: "GESTIONE_INFRASTRUTTURE_STRADALI",
        },
        {
          label: <TranslatedText i18nKey="GRANDE_DISTRIBUZIONE_ORGANIZZATA" />,
          value: "GRANDE_DISTRIBUZIONE_ORGANIZZATA",
        },
        {
          label: <TranslatedText i18nKey="IMPRESA_COSTRUZIONI" />,
          value: "IMPRESA_COSTRUZIONI",
        },
        {
          label: <TranslatedText i18nKey="ISTITUTO_BANCARIO" />,
          value: "ISTITUTO_BANCARIO",
        },
        {
          label: <TranslatedText i18nKey="LABORATORIO_ANALISI" />,
          value: "LABORATORIO_ANALISI",
        },
        {
          label: <TranslatedText i18nKey="LAVANDERIA" />,
          value: "LAVANDERIA",
        },
        {
          label: <TranslatedText i18nKey="LAVANDERIA_INDUSTRIALE" />,
          value: "LAVANDERIA_INDUSTRIALE",
        },
        {
          label: <TranslatedText i18nKey="MAGAZZINI_E_LOGISTICA" />,
          value: "MAGAZZINI_E_LOGISTICA",
        },
        {
          label: <TranslatedText i18nKey="OFFICINA" />,
          value: "OFFICINA",
        },
        {
          label: <TranslatedText i18nKey="PANETTERIA" />,
          value: "PANETTERIA",
        },
        {
          label: <TranslatedText i18nKey="PARRUCCHIERE" />,
          value: "PARRUCCHIERE",
        },
        {
          label: <TranslatedText i18nKey="PASTICCERIA_GELATERIA" />,
          value: "PASTICCERIA_GELATERIA",
        },
        {
          label: <TranslatedText i18nKey="PIZZERIA" />,
          value: "PIZZERIA",
        },
        {
          label: <TranslatedText i18nKey="RISTORANTE" />,
          value: "RISTORANTE",
        },
        {
          label: <TranslatedText i18nKey="SERVIZI_DI_PULIZIA" />,
          value: "SERVIZI_DI_PULIZIA",
        },
        {
          label: <TranslatedText i18nKey="SERVIZI_POSTALI" />,
          value: "SERVIZI_POSTALI",
        },
        {
          label: <TranslatedText i18nKey="SERVIZIO_MENSA" />,
          value: "SERVIZIO_MENSA",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_MEDICO" />,
          value: "STUDIO_MEDICO",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_PROFESSIONALE" />,
          value: "STUDIO_PROFESSIONALE",
        },
        {
          label: <TranslatedText i18nKey="STUDIO_VETERINARIO" />,
          value: "STUDIO_VETERINARIO",
        },
        {
          label: <TranslatedText i18nKey="TABACCHERIA_RICEVITORIA" />,
          value: "TABACCHERIA_RICEVITORIA",
        },
        {
          label: <TranslatedText i18nKey="TELECOMUNICAZIONI" />,
          value: "TELECOMUNICAZIONI",
        },
        {
          label: <TranslatedText i18nKey="TIPOGRAFIA" />,
          value: "TIPOGRAFIA",
        },
        {
          label: <TranslatedText i18nKey="TRAFILERIA" />,
          value: "TRAFILERIA",
        },
        {
          label: (
            <TranslatedText i18nKey="TRASMISSIONI_TELEVISIVE_E_RADIOFONICHE" />
          ),
          value: "TRASMISSIONI_TELEVISIVE_E_RADIOFONICHE",
        },
        {
          label: <TranslatedText i18nKey="TRASPORTO_FERROVIARIO" />,
          value: "TRASPORTO_FERROVIARIO",
        },
        {
          label: <TranslatedText i18nKey="TRASPORTO_PUBBLICO" />,
          value: "TRASPORTO_PUBBLICO",
        },
        {
          label: <TranslatedText i18nKey="UFFICIO_POSTALE" />,
          value: "UFFICIO_POSTALE",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_7.name, "")
        }
      },
    },
    case_7: {
      name: "case_7",
      label: <TranslatedText i18nKey="cases.tipo.uso" />,
      placeholder: (
        <TranslatedText i18nKey="cases.richiedi_omaggio.omaggio.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select-search",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ACCIAIERIA" />,
          value: "ACCIAIERIA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_ALIMENTARE" />,
          value: "AZIENDA_ALIMENTARE",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_CALZATURIERA" />,
          value: "AZIENDA_CALZATURIERA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_CHIMICA" />,
          value: "AZIENDA_CHIMICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_FARMACEUTICA" />,
          value: "AZIENDA_FARMACEUTICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_GRAFICA" />,
          value: "AZIENDA_GRAFICA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_LEGNAMI" />,
          value: "AZIENDA_LEGNAMI",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_PETROLIFERA" />,
          value: "AZIENDA_PETROLIFERA",
        },
        {
          label: <TranslatedText i18nKey="AZIENDA_TESSILE" />,
          value: "AZIENDA_TESSILE",
        },
        {
          label: <TranslatedText i18nKey="CALZATURIFICIO" />,
          value: "CALZATURIFICIO",
        },
        {
          label: <TranslatedText i18nKey="CARTIERA" />,
          value: "CARTIERA",
        },
        {
          label: <TranslatedText i18nKey="CARTOTECNICA" />,
          value: "CARTOTECNICA",
        },
        {
          label: <TranslatedText i18nKey="COLORIFICIO" />,
          value: "COLORIFICIO",
        },
        {
          label: <TranslatedText i18nKey="CONCERIA" />,
          value: "CONCERIA",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_MOBILI" />,
          value: "FABBRICAZIONE_MOBILI",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_PRODOTTI_IN_METALLO" />,
          value: "FABBRICAZIONE_PRODOTTI_IN_METALLO",
        },
        {
          label: (
            <TranslatedText i18nKey="FABBRICAZIONE_PRODOTTI_PER_PULIZIA" />
          ),
          value: "FABBRICAZIONE_PRODOTTI_PER_PULIZIA",
        },
        {
          label: <TranslatedText i18nKey="FABBRICAZIONE_TUBI_E_PROFILATI" />,
          value: "FABBRICAZIONE_TUBI_E_PROFILATI",
        },
        {
          label: <TranslatedText i18nKey="FALEGNAMERIA" />,
          value: "FALEGNAMERIA",
        },
        {
          label: <TranslatedText i18nKey="GESTIONE_SERVIZIO_IDRICO" />,
          value: "GESTIONE_SERVIZIO_IDRICO",
        },
        {
          label: <TranslatedText i18nKey="IMPRESA_COSTRUZIONI" />,
          value: "IMPRESA_COSTRUZIONI",
        },
        {
          label: <TranslatedText i18nKey="LAVORAZIONE_CARNE" />,
          value: "LAVORAZIONE_CARNE",
        },
        {
          label: <TranslatedText i18nKey="LAVORAZIONE_PESCE" />,
          value: "LAVORAZIONE_PESCE",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_MATERIE_PLASTICHE" />,
          value: "PRODUZIONE_MATERIE_PLASTICHE",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_PRODOTTI_ALIMENTARI" />,
          value: "PRODUZIONE_PRODOTTI_ALIMENTARI",
        },
        {
          label: <TranslatedText i18nKey="PRODUZIONE_PRODOTTI_PER_ANIMALI" />,
          value: "PRODUZIONE_PRODOTTI_PER_ANIMALI",
        },
        {
          label: <TranslatedText i18nKey="RACCOLTA_SMALTIMENTO_RIFIUTI" />,
          value: "RACCOLTA_SMALTIMENTO_RIFIUTI",
        },
        {
          label: <TranslatedText i18nKey="RAFFINERIA" />,
          value: "RAFFINERIA",
        },
        {
          label: <TranslatedText i18nKey="SIDERURGIA" />,
          value: "SIDERURGIA",
        },
        {
          label: <TranslatedText i18nKey="TRASMISSIONE_ENERGIA_ELETTRICA" />,
          value: "TRASMISSIONE_ENERGIA_ELETTRICA",
        },
      ],
      onChange: (selected, values, setFieldValue) => {
        if (selected) {
          setFieldValue(case_2_1.name, "")
          setFieldValue(case_2_2.name, "")
          setFieldValue(case_2_3.name, "")
          setFieldValue(case_2_4.name, "")
          setFieldValue(case_3_1.name, "")
          setFieldValue(case_3.name, "")
          setFieldValue(case_4_1.name, "")
          setFieldValue(case_4_2.name, "")
          setFieldValue(case_4_3.name, "")
          setFieldValue(case_5.name, "")
          setFieldValue(case_6.name, "")
        }
      },
    },

    tipologiaUsoNonDomestica: {
      name: "tipologiaUsoNonDomestica",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.industriale.label" />
          ),
          value: AreaClassification.INDUSTRIAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.agricolo.label" />
          ),
          value: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.artigianale.label" />
          ),
          value: AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.pubblico.label" />
          ),
          value: AreaClassification.PUBLIC,
          grid: { xs: 12, md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.voltura.tipologia_uso.non_domestica.altro.label" />
          ),
          value: AreaClassification.OTHER,
          grid: { xs: 12, md: 4 },
        },
      ],
    },
    numeroResidenti: {
      name: "numeroResidenti",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.numero_residenti.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    residentialUnits: {
      name: "residentialUnits",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.condominiale.unita.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    housingUnits: {
      name: "housingUnits",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.condominiale.residenti.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    notResidentialUnits: {
      name: "notResidentialUnits",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.condominiale.unita_altri.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    notDomesticUseActivity: {
      name: "notDomesticUseActivity",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.attivita.label" />
      ),
      placeholder:  <TranslatedText i18nKey="cases.allacciamento.step5_1.tipologiaDiAttivita.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    tipologiaIntestatario: {
      name: "tipologiaIntestatario",
      label: (
        <TranslatedText i18nKey="cases.tipologia_intestatario_label.step5_1" />
      ),
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_professionista_5_1" />
          ),
          value: TipologiaIntestatario.PROFESSIONISTA,
          grid: { xs: 12 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_microimpresa_5_1" />
          ),
          value: TipologiaIntestatario.MICROIMPRESA,
          grid: { xs: 12 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.tipologia_intestatario_nessuno_5_1" />
          ),
          value: TipologiaIntestatario.NESSUNA,
          grid: { xs: 12 },
        },
      ],
    },
    areraClassificationOther:{
      name: "areraClassificationOther",
      placeholder: <TranslatedText i18nKey="cases.voltura.other.insert.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      summaryLabel: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.domestico.altro.label" />
      ),
      type: "input",
    },
    // step 5.2
    estremiDelDocumento: {
      name: "estremiDelDocumento",
      label: (
        <TranslatedText i18nKey="cases.voltura.estremi_del_documento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    estremiDelDocumento1: {
      name: "estremiDelDocumento1",
      label: (
        <TranslatedText i18nKey="cases.voltura.estremi_del_documento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    // step 6
    bollettaOnlineAttiva: {
      name: "bollettaOnlineAttiva",
      label: (
        <TranslatedText i18nKey="cases.voltura.bolletta_online_attiva.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "checkbox",
    },

    // step 7
    bollettaAddebitoBancario: {
      name: "bollettaAddebitoBancario",
      label: (
        <TranslatedText i18nKey="cases.voltura.bolletta_addebito_bancario.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "checkbox",
    },
    cognomeNomeDelConto: {
      name: "cognomeNomeDelConto",
      label: <TranslatedText i18nKey="cases.voltura.cognome_del_conto.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.cognome_del_conto.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",

    },
    codiceFiscaleTitolare: {
      name: "codiceFiscaleTitolare",
      label: (
        <TranslatedText i18nKey="cases.voltura.codice_fiscale_titolare.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      uppercase: true,
    },
    indirizzoDomiciliazione: {
      name: "indirizzoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(indirizzoDomiciliazione.name, isStreetValid ? `${components.via}, ${components.civico}, ${components.comune}` : '');
        egonCodeResponse.tipo_Indirizzo="domiciliazione";
        indirizzoDomiciliazione.egonCodeResponse=egonCodeResponse;
      },
      step : "7",
    },
    telefonoDomiciliazione: {
      name: "telefonoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.telefono.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    cellulareDomiciliazione: {
      name: "cellulareDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bankName: {
      name: "bankName",
      label: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.nome_banca.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.nome_banca.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true
    },
    agencia: {
      name: "agencia",
      label: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.agenzia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.domicialiazone.agenzia.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true
    },
    iban: {
      name: 'iban',
      label: <TranslatedText i18nKey="cases.voltura.iban.label" />,
      labelButton: <TranslatedText i18nKey="cases.voltura.iban.labelButton.validation.text" />,
      invalidErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.not_supported' />),
      requiredErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.required' />),
      modalInfoContent: <TranslatedText i18nKey="cases.voltura.iban.modalInfoContent" />,
      modalInfoButtonText: <TranslatedText i18nKey="cases.voltura.iban.modalInfoButtonText" />,
      relatedInfo: [
        { 'bankName': 'bankName' },
        { 'agency': 'agencia' }
      ],
      type: 'iban',
    },

    // step 8
    //privacy policy

    // step 9
    idType: {
      name: "idType",
      label: <TranslatedText i18nKey="cases.digitalization.idType.placeholder" />,
      placeholder: (<TranslatedText i18nKey="cases.richiedi_omaggio.idType.placeholder" />),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ID" />,
          value: "ID",
        },
        {
          label: <TranslatedText i18nKey="Passport" />,
          value: "Passport",
        },
        {
          label: <TranslatedText i18nKey="Driving_licence" />,
          value: "Driving_licence",
        },
      ],
    },
    Legittima: {
      name: "Legittima",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.Legittima.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "legittima", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    codiceFiscaleDoc: {
      name: "codiceFiscaleDoc",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codiceFiscaleDoc.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "codiceFiscaleDoc", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    verbale: {
      name: "verbale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.verbale.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "verbale", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    CCIAA: {
      name: "CCIAA",
      label: <TranslatedText i18nKey="cases.request_info.fields.CCIAA.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "CCIAA", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    ID: {
      name: "ID",
      label: <TranslatedText i18nKey="cases.request_info.fields.ID.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      // prefixFileName: 'voltura', //this set for analisi acqua
      prefixFileNameFromInternalFiledName: "idType",
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    dichiarazione: {
      name: "dichiarazione",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.dichiarazione.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "dichiarazione", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
  },
};

const {
  formField: {
    // step 1.1
    codiceContratto,
    numeroFattura,
    matricolaContatoreCaseFirstStep,
    volturaMortisCausa,
    // step 1.2
    comune,
    via,
    codicePrecedenteUtente,
    matricolaContatore,
    // step 1.3
    tipoIntestatario,
    fisicaNome,
    fisicaCognome,
    fisicaCodiceFiscale,
    fisicaNatoA,
    fisicaDataNascita,
    fisicaSesso,
    fisicaVia,
    fisicaComuneResidenza,
    fisicaProvincia,
    fisicaCAP,
    giuridicaRagioneSociale,
    giuridicaCodiceFiscale,
    giuridicaPartitaIVA,
    giuridicaPartitaIVA2,
    giuridicaPartitaIVAGrupoCheckbox,
    giuridicaPartitaIVAGrupo,
    giuridicaNome,
    giuridicaCognome,
    giuridicaIndirizzo,
    giuridicaSedeLegaleComune,
    giuridicaProvincia,
    giuridicaCAP,
    // step 2.1
    codiceDestinatarioPA,
    userRole,
    indirizzoPEC,
    codiceCIG,
    codiceCUP,
    splitPaymentCat,
    codiceDestinatarioSDI,
    // step 3.1
    signValue,
    bollettaRecapitoTipo,
    bollettaRecapitoNuovoIndirizzo,
    bollettaPuntoDiFurnitura,
    bollettaDatiIntestatario,
    bollettaIndirizzo,
    bollettaComune,
    bollettaCap,
    bollettaProvincia,
    bollettaNomePresso,
    bollettaCognomePresso,
    bollettaFisso,
    bollettaCellulare,
    bollettaEmail,
    bollettaConfirmEmail,
    bollettaPec,
    // step 4.1
    inQualitaDi,
    holderOther,
    ilSottoscrittoNome,
    ilSottoscrittoCognome,
    ownerStatus,
    lettura,
    registeredNumber,
    registeredDate,
    presaIdrica,
    letturaPossessoImmobile,
    dataPossessoImmobile,
    ownerOther,
    ownerOtherInsert,
    dataDecorrenza,
    letturaDecorrenza,
    // step 3.1 Mortis Causa
    inQualitaDiMortisCausa,
    ilSottoscrittoNomeMortisCausa,
    ilSottoscrittoCognomeMortisCausa,
    soleHeirStatusMortisCausa,
    ownerMortisCausa,
    dateOwnerMortisCausa,
    degreeOfKinship,
    degreeOfKinshipOther,
    supplyContractMortisCausa,
    cityMortisCausa,
    streetMortisCausa,
    dateLastMeterReadingMortisCausa,
    valueMeterReadingMortisCausa,
    // step 4.2
    codiceUtente,
    nomeCognome,
    letturaFinale,
    recapitoBolletta,
    // step 4.3
    tipo,
    datiCatastaliComuneAmministrativo,
    datiCatastaliProvincia,
    datiCatastaliComuneCatastale,
    datiCatastaliProvinciaCatastale,
    datiCatastaliIndirizzo,
    datiCatastaliNumeroCivico,
    datiCatastaliEdificio,
    datiCatastaliScala,
    datiCatastaliPiano,
    datiCatastaliAppartamento,
    datiCatastaliCodiceComuneCatastale,
    datiCatastaliSezioneUrbana,
    datiCatastaliComuneFoglio,
    datiCatastaliParticella,
    datiCatastaliSubalterno,

    // step 5.1
    tipologiaUso,
    tipologiaUsoDomestica,
    tipologiaUsoNonDomestica,
    numeroResidenti,
    residentialUnits,
    housingUnits,
    notResidentialUnits,
    notDomesticUseActivity,
    tipologiaIntestatario,
    areraClassificationOther,
    case_2,
    case_2_1,
    case_2_2,
    case_2_3,
    case_2_4,
    case_3,
    case_3_1,
    case_4,
    case_4_1,
    case_4_2,
    case_4_3,
    case_5,
    case_6,
    case_7,
    // step 5.2
    estremiDelDocumento,
    estremiDelDocumento1,

    // step 6
    bollettaOnlineAttiva,

    // step 7
    bollettaAddebitoBancario,
    cognomeNomeDelConto,
    codiceFiscaleTitolare,
    bankName,
    indirizzoDomiciliazione,
    telefonoDomiciliazione,
    cellulareDomiciliazione,
    agencia,
    iban,

    // step 8
    //privacy policy

    // step 9
    Legittima,
    codiceFiscaleDoc,
    verbale,
    CCIAA,
    ID,
    idType,
    dichiarazione,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  // step 1.1
  [codiceContratto.name]: "",
  [numeroFattura.name]: "",
  [matricolaContatoreCaseFirstStep.name]: "",
  [volturaMortisCausa.name]: false,

  // step 1.2
  [comune.name]: "",
  [via.name]: "",
  [codicePrecedenteUtente.name]: "",
  [matricolaContatore.name]: "",

  // step 1.3
  [tipoIntestatario.name]: PersonType.NATURAL,
  [fisicaNome.name]: "",
  [fisicaCognome.name]: "",
  [fisicaCodiceFiscale.name]: "",
  [fisicaNatoA.name]: "",
  [fisicaDataNascita.name]: "",
  [fisicaSesso.name]: PersonSex.M,
  [fisicaVia.name]: "",
  [fisicaComuneResidenza.name]: "",
  [fisicaProvincia.name]: "",
  [fisicaCAP.name]: "",
  [giuridicaRagioneSociale.name]: "",
  [giuridicaCodiceFiscale.name]: "",
  [giuridicaPartitaIVA.name]: "",
  [giuridicaPartitaIVA2.name]: "",
  [giuridicaPartitaIVAGrupoCheckbox.name]: false,
  [giuridicaPartitaIVAGrupo.name]: "",
  [giuridicaNome.name]: "",
  [giuridicaCognome.name]: "",
  [giuridicaIndirizzo.name]: "",
  [giuridicaSedeLegaleComune.name]: "",
  [giuridicaProvincia.name]: "",
  [giuridicaCAP.name]: "",

  // step 2.1
  [codiceDestinatarioPA.name]: "",
  [userRole.name]: "",
  [indirizzoPEC.name]: "",
  [codiceCIG.name]: "",
  [codiceCUP.name]: "",
  [splitPaymentCat.name]: "",
  [codiceDestinatarioSDI.name]: "",

  // step 3.1
  [signValue.name]: "",
  [bollettaRecapitoNuovoIndirizzo.name]: TipoBollettaRecapito.NUOVO,
  [bollettaRecapitoTipo.name]: TipoBollettaRecapito.PRE_ESISTENTE,
  [bollettaPuntoDiFurnitura.name]: "",
  [bollettaDatiIntestatario.name]: "",
  [bollettaIndirizzo.name]: "",
  [bollettaComune.name]: "",
  [bollettaCap.name]: "",
  [bollettaProvincia.name]: "",
  [bollettaNomePresso.name]: "",
  [bollettaCognomePresso.name]: "",
  [bollettaFisso.name]: "",
  [bollettaCellulare.name]: "",
  [bollettaEmail.name]: "",
  [bollettaConfirmEmail.name]: "",
  [bollettaPec.name]: "",

  // step 4.1
  [inQualitaDi.name]: AccountHolderType.OWNER,
  [holderOther.name]: "",
  [ilSottoscrittoNome.name]: "",
  [ilSottoscrittoCognome.name]: "",
  [ownerStatus.name]: true,
  [lettura.name]: "",
  [registeredNumber.name]: "",
  [registeredDate.name]: "",
  [presaIdrica.name]: "true",
  [letturaPossessoImmobile.name]: "",
  [dataPossessoImmobile.name]: "",
  [ownerOther.name]: false,
  [ownerOtherInsert.name]: "",
  [dataDecorrenza.name]: "",
  [letturaDecorrenza.name]: "",
  // step 3.1 Mortis Causa
  [inQualitaDiMortisCausa.name]: AccountHolderType.OWNER,
  [ilSottoscrittoNomeMortisCausa.name]: "",
  [ilSottoscrittoCognomeMortisCausa.name]: "",
  [soleHeirStatusMortisCausa.name]: TypeHeir.SOLE,
  [ownerMortisCausa.name]:"",
  [dateOwnerMortisCausa.name]:"",
  [degreeOfKinship.name]:RelationshipType.SPOUSE,
  [degreeOfKinshipOther.name]:"",
  [supplyContractMortisCausa.name]:false,
  [cityMortisCausa.name]:"",
  [streetMortisCausa.name]:"",
  [dateLastMeterReadingMortisCausa.name]:"",
  [valueMeterReadingMortisCausa.name]:"",
  // step 4.2
  [codiceUtente.name]: "",
  [nomeCognome.name]: "",
  [letturaFinale.name]: "",
  [recapitoBolletta.name]: "",

  // step 4.3
  [tipo.name]: CadastreType.MANUFACTURED,
  [datiCatastaliComuneAmministrativo.name]: "",
  [datiCatastaliProvincia.name]: "",
  [datiCatastaliComuneCatastale.name]: "",
  [datiCatastaliProvinciaCatastale.name]: "",
  [datiCatastaliIndirizzo.name]: "",
  [datiCatastaliNumeroCivico.name]: "",
  [datiCatastaliEdificio.name]: "",
  [datiCatastaliScala.name]: "",
  [datiCatastaliPiano.name]: "",
  [datiCatastaliAppartamento.name]: "",
  [datiCatastaliCodiceComuneCatastale.name]: "",
  [datiCatastaliSezioneUrbana.name]: "",
  [datiCatastaliComuneFoglio.name]: "",
  [datiCatastaliParticella.name]: "",
  [datiCatastaliSubalterno.name]: "",

  // step 5.1
  [tipologiaUso.name]: TipologiaUsoFornitura.DOMESTICO,
  [tipologiaUsoDomestica.name]: AreaClassification.RESIDENT_DOMESTIC_USE,
  [tipologiaUsoNonDomestica.name]: AreaClassification.INDUSTRIAL_USE,
  [numeroResidenti.name]: "",
  [residentialUnits.name]: "",
  [housingUnits.name]: "",
  [notResidentialUnits.name]: "",
  [notDomesticUseActivity.name]: "",
  [tipologiaIntestatario.name]: "",
  [areraClassificationOther.name]: "",
  [case_2.name]: "",
  [case_2_1.name]: "",
  [case_2_2.name]: "",
  [case_2_3.name]: "",
  [case_2_4.name]: "",
  [case_3.name]: "",
  [case_3_1.name]: "",
  [case_4.name]: "",
  [case_4_1.name]: "",
  [case_4_2.name]: "",
  [case_4_3.name]: "",
  [case_5.name]: "",
  [case_6.name]: "",
  [case_7.name]: "",
  // step 5.2
  [estremiDelDocumento.name]: "",
  [estremiDelDocumento1.name]: "",

  // step 6
  [bollettaOnlineAttiva.name]: false,

  // step 7
  [bollettaAddebitoBancario.name]: false,
  [cognomeNomeDelConto.name]: "",
  [codiceFiscaleTitolare.name]: "",
  [bankName.name]: "",
  [indirizzoDomiciliazione.name]: "",
  [telefonoDomiciliazione.name]: "",
  [cellulareDomiciliazione.name]: "",
  [agencia.name]: "",
  [iban.name]: "",

  // step 8
  //privacy policy

  // step 9
  [Legittima.name]: "",
  [codiceFiscaleDoc.name]: "",
  [verbale.name]: "",
  [CCIAA.name]: "",
  [ID.name]: "",
  [idType.name]: "",
  [dichiarazione.name]: "",
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = (buttonMatricolaContatoreCase) => {
  const validationFiscalCode = getValidationRule("fiscalCode");
  const validationFiscalCodeOrVAT = getValidationRule("fiscalCodeOrVAT");
  const validationPhoneNumber = getValidationRule("phone");
  const validationEmail = getValidationRule("email");
  const validationNumber = getValidationRule("number");
  const validationBusinessName = getValidationObject("businessName");
  let validationSchemaFirstStep;
  if (buttonMatricolaContatoreCase) {
    validationSchemaFirstStep = {
      [codiceContratto.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true),
      [numeroFattura.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true),
      [matricolaContatoreCaseFirstStep.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(matricolaContatoreCaseFirstStep.requiredErrorMsg),
      [volturaMortisCausa.name]: Yup.string()
    }
  }
  else {
    validationSchemaFirstStep = {
      [codiceContratto.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(codiceContratto.requiredErrorMsg),
      [numeroFattura.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(numeroFattura.requiredErrorMsg),
      [matricolaContatoreCaseFirstStep.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true),
      [volturaMortisCausa.name]: Yup.string()
    }
  }
  let inQualitaDiValue;
  if(!volturaMortisCausa.volturaMortisCausaCheckbox){
    inQualitaDiValue = inQualitaDi.name;
  }
  else {
    inQualitaDiValue = inQualitaDiMortisCausa.name;
  }
  return [
    // step 1.1
    Yup.object().shape(validationSchemaFirstStep),
    // step 1.2
    Yup.object().shape({
      [comune.name]: Yup.string().required(comune.requiredErrorMsg),
      [via.name]: Yup.string().required(via.requiredErrorMsg),
      [codicePrecedenteUtente.name]: Yup.string().required(
        codicePrecedenteUtente.requiredErrorMsg
      ),
      [matricolaContatore.name]: Yup.string().required(
        matricolaContatore.requiredErrorMsg
      ),
    }),
    // step 1.3
    Yup.object().shape({
      [tipoIntestatario.name]: Yup.string()
        .oneOf(
          tipoIntestatario.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      // Persona fisica
      [fisicaNome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .max(
            50,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .required(fisicaNome.requiredErrorMsg),
      }),
      [fisicaCognome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .max(
            50,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .required(fisicaCognome.requiredErrorMsg),
      }),
      [fisicaCodiceFiscale.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCode, {
            message: fisicaCodiceFiscale.invalidErrorMsg,
          })
          .required(fisicaCodiceFiscale.requiredErrorMsg),
      }),
      [fisicaNatoA.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(fisicaNatoA.requiredErrorMsg),
      }),
      [fisicaDataNascita.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(fisicaDataNascita.requiredErrorMsg),
      }),
      [fisicaSesso.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .oneOf(
            fisicaSesso.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(
            <TranslatedText i18nKey="cases.request_info.errors.required" />
          ),
      }),
      [fisicaComuneResidenza.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(fisicaComuneResidenza.requiredErrorMsg),
      }),
      [fisicaCAP.name]: Yup.number().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.number()
          .typeError(fisicaCAP.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [fisicaVia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(fisicaVia.requiredErrorMsg),
      }),
      [fisicaProvincia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true).max(2, <TranslatedText i18nKey="province.length" />)
          .required(fisicaProvincia.requiredErrorMsg),
      }),
      // Persona giuridica
      [giuridicaRagioneSociale.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .matches(validationBusinessName.regex
            , {
              message: (
                <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
              ),
            })
          .required(giuridicaRagioneSociale.requiredErrorMsg),
      }),
      [giuridicaCodiceFiscale.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVA.name], {
        is: (field, giuridicaPartitaIVA) => field === PersonType.LEGAL && !giuridicaPartitaIVA,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaPartitaIVA2.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, giuridicaPartitaIVAGrupoCheckbox) => field === PersonType.LEGAL && giuridicaPartitaIVAGrupoCheckbox,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaPartitaIVAGrupo.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, checkbox) => field === PersonType.LEGAL && checkbox === true,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })

          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [giuridicaNome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .max(
            50,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .required(giuridicaNome.requiredErrorMsg),
      }),
      [giuridicaCAP.name]: Yup.number().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.number()
          .typeError(giuridicaCAP.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaCognome.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .max(
            50,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .required(giuridicaCognome.requiredErrorMsg),
      }),
      [giuridicaIndirizzo.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string().required(giuridicaIndirizzo.requiredErrorMsg),
      }),
      [giuridicaSedeLegaleComune.name]: Yup.string().when(
        tipoIntestatario.name,
        {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(giuridicaSedeLegaleComune.requiredErrorMsg),
        }
      ),
      [giuridicaProvincia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true).max(2, <TranslatedText i18nKey="province.length" />)
          .required(giuridicaProvincia.requiredErrorMsg),
      }),
    }),
    // step 2.1

    Yup.object().shape({
      [giuridicaPartitaIVA.name]: Yup.string().when([tipoIntestatario.name, giuridicaCodiceFiscale.name], {
        is: (field, giuridicaCodiceFiscale) => field === PersonType.LEGAL && !giuridicaCodiceFiscale,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [codiceDestinatarioPA.name]: Yup.string().when(userRole.name, {
        is: UserRoleEnum.MUNICIPAL_USER,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(codiceDestinatarioPA.requiredErrorMsg),
      }),
      [indirizzoPEC.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationEmail, { message: indirizzoPEC.invalidErrorMsg }),
    }),
    // step 3.1
    Yup.object().shape({
      [bollettaCellulare.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationPhoneNumber, {
          message: bollettaCellulare.invalidErrorMsg,
        })
        .required(giuridicaCodiceFiscale.requiredErrorMsg),

      [bollettaEmail.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationEmail, { message: bollettaEmail.invalidErrorMsg })
        .required(bollettaEmail.requiredErrorMsg),
      [bollettaConfirmEmail.name]: Yup.string().when([signValue.name], {
        is: (signValue) => signValue === true,
        then: Yup.string()
          .oneOf(
            [Yup.ref("bollettaEmail"), null],
            <TranslatedText i18nKey="cases.request_info.email.match" />
          )
          .required(bollettaComune.requiredErrorMsg),
      }),
      [bollettaIndirizzo.name]: Yup.string()
      .strict(true)
      .required(bollettaIndirizzo.requiredErrorMsg),

      [bollettaComune.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(bollettaComune.requiredErrorMsg),

      [bollettaProvincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(bollettaProvincia.requiredErrorMsg),
      [bollettaCap.name]: Yup.string().required(
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      [bollettaFisso.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationPhoneNumber, {
          message: bollettaFisso.invalidErrorMsg,
        }),
      [bollettaPec.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationEmail, { message: bollettaPec.invalidErrorMsg }),
    }),
    // step 4.1
    Yup.object().shape({
      [inQualitaDi.name]: Yup.string()
        .oneOf(
          inQualitaDi.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ilSottoscrittoNome.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(ilSottoscrittoNome.requiredErrorMsg),
      [ilSottoscrittoCognome.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(ilSottoscrittoCognome.requiredErrorMsg),
      [registeredNumber.name]: Yup.number()
        .when([ownerStatus.name, inQualitaDi.name], {
          is: (ownerStatus, field) =>
            ownerStatus === true && field === AccountHolderType.OWNER,
          then: Yup.number()
            .required(registeredNumber.requiredErrorMsg)
            .typeError(registeredNumber.invalidErrorMsg),
        })
        .typeError(registeredNumber.invalidErrorMsg),
      [registeredDate.name]: Yup.string()
        .when([ownerStatus.name, inQualitaDi.name], {
          is: (ownerStatus, field) =>
            ownerStatus === true && field === AccountHolderType.OWNER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(registeredDate.requiredErrorMsg)
            .typeError(<TranslatedText i18nKey="common.empty_characters" />),
        })
        .typeError(<TranslatedText i18nKey="common.empty_characters" />),
      [dataPossessoImmobile.name]: Yup.string()
        .when([ownerStatus.name], {
          is: (ownerStatus) => ownerStatus === false,
          then: Yup.string()
            .required(registeredDate.requiredErrorMsg)
            .typeError(<TranslatedText i18nKey="common.empty_characters" />),
        })
        .typeError(<TranslatedText i18nKey="common.empty_characters" />),
      [letturaPossessoImmobile.name]: Yup.number()
        .when([ownerStatus.name], {
          is: (ownerStatus) => ownerStatus === false,
          then: Yup.number()
            .required(letturaPossessoImmobile.requiredErrorMsg)
            .typeError(<TranslatedText i18nKey="common.empty_characters" />),
        })
        .typeError(letturaPossessoImmobile.invalidErrorMsg)
        .min(
          0,
          <TranslatedText i18nKey="cases.request_info.fields.selfreading.min" />
        ),
      [presaIdrica.name]: Yup.string()
        .oneOf(
          presaIdrica.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [dataDecorrenza.name]: Yup.string().required(
        dataDecorrenza.requiredErrorMsg
      ),
      [letturaDecorrenza.name]: Yup.number()
        .typeError(letturaDecorrenza.invalidErrorMsg)
        .min(
          0,
          <TranslatedText i18nKey="cases.request_info.fields.selfreading.min" />
        )
        .required(letturaDecorrenza.requiredErrorMsg),
    }),
     // step 3.1 Mortis Causa
     Yup.object().shape({
      [inQualitaDiMortisCausa.name]: Yup.string()
        .oneOf(
          inQualitaDiMortisCausa.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ilSottoscrittoNomeMortisCausa.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(ilSottoscrittoNomeMortisCausa.requiredErrorMsg),
      [ilSottoscrittoCognomeMortisCausa.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(ilSottoscrittoCognomeMortisCausa.requiredErrorMsg),
      [ownerMortisCausa.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(ownerMortisCausa.requiredErrorMsg),
      [dateOwnerMortisCausa.name]: Yup.string()
        .required(dateOwnerMortisCausa.requiredErrorMsg),
      [cityMortisCausa.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(cityMortisCausa.requiredErrorMsg),
      [streetMortisCausa.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(streetMortisCausa.requiredErrorMsg),
      [dateLastMeterReadingMortisCausa.name]: Yup.string()
        .required(dateLastMeterReadingMortisCausa.requiredErrorMsg),
      [valueMeterReadingMortisCausa.name]: Yup.number()
        .required(valueMeterReadingMortisCausa.requiredErrorMsg)
        .typeError("invalid error")
        .min(
          0,
          <TranslatedText i18nKey="cases.request_info.fields.selfreading.min" />
        ),
      }),
    // step 4.2
    Yup.object().shape({
      [tipo.name]: Yup.string()
        .oneOf(
          tipo.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [codiceUtente.name]: Yup.number()
        .typeError(codiceUtente.invalidErrorMsg)
        .required(codiceUtente.requiredErrorMsg),
      [nomeCognome.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(nomeCognome.requiredErrorMsg),
      [letturaFinale.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationNumber, { message: letturaFinale.invalidErrorMsg })
        .required(letturaFinale.requiredErrorMsg),
      [recapitoBolletta.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(recapitoBolletta.requiredErrorMsg),
    }),

    // step 4.3
    Yup.object().shape({
      [tipo.name]: Yup.string()
        .oneOf(
          tipo.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [datiCatastaliComuneAmministrativo.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(datiCatastaliComuneAmministrativo.requiredErrorMsg),
      [datiCatastaliProvincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(datiCatastaliProvincia.requiredErrorMsg),
      [datiCatastaliProvinciaCatastale.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(datiCatastaliProvinciaCatastale.requiredErrorMsg),
      [datiCatastaliIndirizzo.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(datiCatastaliIndirizzo.requiredErrorMsg),
      [datiCatastaliNumeroCivico.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(datiCatastaliNumeroCivico.requiredErrorMsg),
      [datiCatastaliEdificio.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliScala.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliPiano.name]: Yup.string().max(3, <TranslatedText i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliAppartamento.name]: Yup.string().max(3, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliCodiceComuneCatastale.name]: Yup.string().max(5, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliSezioneUrbana.name]: Yup.string().max(3, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliComuneFoglio.name]: Yup.string().max(4, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliParticella.name]: Yup.string().max(5, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
      [datiCatastaliSubalterno.name]: Yup.string().max(4, <TranslatedText
        i18nKey="errors.registration.admin.fc.long" />),
    }),
    // step 5.1
    Yup.object().shape({
      [tipologiaUso.name]: Yup.string()
        .oneOf(
          tipologiaUso.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [tipologiaUsoNonDomestica.name]: Yup.string().when(tipologiaUso.name, {
        is: (field) => field === TipologiaUsoFornitura.NON_DOMESTICO,
        then: Yup.string()
          .oneOf(
            tipologiaUsoNonDomestica.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(tipologiaUsoNonDomestica.requiredErrorMsg),
      }),
      [tipologiaUsoDomestica.name]: Yup.string().when(tipologiaUso.name, {
        is: (field) => field === TipologiaUsoFornitura.DOMESTICO,
        then: Yup.string()
          .oneOf(
            tipologiaUsoDomestica.options.map((option) => option.value),
            <TranslatedText i18nKey="common.errors.notValid" />
          )
          .required(tipologiaUsoDomestica.requiredErrorMsg),
      }),
      [case_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "Istituti scolastici",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "CASE_DI_CURA_E_DI_ASSISTENZA",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_2_4.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "OSPEDALI_E_STRUTTURE_OSPEDALIERE",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "PRESE_ANTINCENDIO",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_3_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_2.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_2) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_2 === "ALTRO",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_5.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica ===
            AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_6.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica ===
            AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_7.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.INDUSTRIAL_USE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.OTHER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_1.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === "USO DIVERSO",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_2.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [case_4_3.name]: Yup.string().when(
        [tipologiaUso.name, tipologiaUsoNonDomestica.name, case_4.name],
        {
          is: (tipologiaUso, tipologiaUsoNonDomestica, case_4) =>
            tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO &&
            tipologiaUsoNonDomestica === AreaClassification.PUBLIC &&
            case_4 === "USO IRRIGUO E COLLETTIVO",
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(case_2.requiredErrorMsg),
        }
      ),
      [numeroResidenti.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.RESIDENT_DOMESTIC_USE,
          then: Yup.number()
            .min(
              1,
              <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min" />
            )
            .max(9, <TranslatedText i18nKey="cases.request_info.fields.max" />)
            .typeError(numeroResidenti.invalidErrorMsg)
            .required(numeroResidenti.requiredErrorMsg),
        }
      ),
      [notResidentialUnits.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number()
            .max(
              1000,
              <TranslatedText i18nKey="cases.request_info.fields.max1000" />
            )
            .typeError(residentialUnits.invalidErrorMsg)
            .required(residentialUnits.requiredErrorMsg),
        }
      ),
      [residentialUnits.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number().min(1, <TranslatedText i18nKey="cases.request_info.fields.notResidentialUnits.min" />)
            .max(
              1000,
              <TranslatedText i18nKey="cases.request_info.fields.max1000" />
            )
            .typeError(residentialUnits.invalidErrorMsg)
            .required(residentialUnits.requiredErrorMsg),
        }
      ),
      [housingUnits.name]: Yup.number().when(
        [tipologiaUso.name, tipologiaUsoDomestica.name],
        {
          is: (tipologiaUso, tipologiaUsoDomestica) =>
            tipologiaUso === TipologiaUsoFornitura.DOMESTICO &&
            tipologiaUsoDomestica === AreaClassification.CONDOMINIUM_USE,
          then: Yup.number().min(1, <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min" />)
            .max(
              1000,
              <TranslatedText i18nKey="cases.request_info.fields.max1000" />
            )
            .typeError(residentialUnits.invalidErrorMsg)
            .required(residentialUnits.requiredErrorMsg),
        }
      ),
      [tipologiaIntestatario.name]: Yup.string().when([tipologiaUso.name, tipologiaUsoNonDomestica.name], {
        is: (tipologiaUso, tipologiaUsoNonDomestica) =>
          tipologiaUso === TipologiaUsoFornitura.NON_DOMESTICO && (tipologiaUsoNonDomestica === AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE || tipologiaUsoNonDomestica === AreaClassification.ARTISAN_AND_COMMERCIAL_USE),
        then: Yup.string().oneOf(
          tipologiaIntestatario.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        ).required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      }),
    }),
    //step 5.2
    Yup.object().shape({
      [estremiDelDocumento1.name]: Yup.string().when([signValue.name,], {
        is: (signValue) => signValue === false,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
    }),
    // step 6
    Yup.object().shape({}),
    // step 7
    Yup.object().shape({
      [cognomeNomeDelConto.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationBusinessName.regex
              , {
                message: (
                  <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
                ),
              })
            .required(cognomeNomeDelConto.requiredErrorMsg),
        }
      ),
      [codiceFiscaleTitolare.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .min(
              11,
              <TranslatedText i18nKey="errors.registration.public.fc.short" />
            )
            .max(
              16,
              <TranslatedText i18nKey="errors.registration.public.fc.long" />
            )
            .matches(validationFiscalCode, {
              message: codiceFiscaleTitolare.invalidErrorMsg,
            })
            .required(codiceFiscaleTitolare.requiredErrorMsg),
        }
      ),
      [cellulareDomiciliazione.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhoneNumber, {
              message: cellulareDomiciliazione.invalidErrorMsg,
            })
            .required(cellulareDomiciliazione.requiredErrorMsg),
        }
      ),
      [telefonoDomiciliazione.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .matches(validationPhoneNumber, {
          message: telefonoDomiciliazione.invalidErrorMsg,
        }),
      // [bankName.name]: Yup.string().when(
      //   bollettaAddebitoBancario.name,
      //   {
      //     is: true,
      //     then: Yup.string()
      //       .trim(<TranslatedText i18nKey="common.empty_characters" />)
      //       .strict(true)
      //       .required(bankName.requiredErrorMsg),
      //   }
      // ),
      [iban.name]: Yup.string().when(bollettaAddebitoBancario.name, {
        is: true,
        then: Yup.string()
          .required(iban.requiredErrorMsg)
          .min(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .max(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .matches(/[A-Z]/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_check" />
            ),
          })
          .matches(/IT[A-Z0-9]{2}\s?/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_digits" />
            )
          }),
      }),
    }),
    // step 8
    Yup.object().shape({}),
    //step 9
    Yup.object().shape({
      [estremiDelDocumento.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />)
        .strict(true)
        .required(estremiDelDocumento.requiredErrorMsg),
      [idType.name]: Yup.string()
        .oneOf(
          idType.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ID.name]: Yup.mixed()
        .required(<TranslatedText i18nKey="cases.errors.required" />)
        .test("fileSize", "Your file", (value) => value && value !== undefined),

      [Legittima.name]: Yup.mixed().when(inQualitaDiValue, {
        is: (field) =>
          field === AccountHolderType.CONDOMINIUM_ADMIN ||
          field === AccountHolderType.USUFRUCTUARY ||
          field === AccountHolderType.TENANT ||
          field === AccountHolderType.LEGAL_REPRESENTATIVE ||
          field === AccountHolderType.OTHER,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [codiceFiscaleDoc.name]: Yup.mixed().when(inQualitaDiValue, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [verbale.name]: Yup.mixed().when(inQualitaDiValue, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [CCIAA.name]: Yup.mixed().when(inQualitaDiValue, {
        is: (field) => field === AccountHolderType.LEGAL_REPRESENTATIVE,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [dichiarazione.name]: Yup.mixed().when(case_2.name, {
        is: (field) => field === "PRESE_ANTINCENDIO",
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
    }),
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return [
    // step 1.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.voltura.layout.inoltro_richiesta.chapter_name" />
      ),
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.inoltro_richiesta.title_1" />
      ),
      beforeSubmit: async (values, { setFieldValue, setErrors }, buttonMatricolaContatoreCase) => {
        let queryObject;
        if (buttonMatricolaContatoreCase) {
          queryObject = {
            query: GET_CONTRACT_METRESERIALNUMBER,
            variables: {
              metreSerialNumber: values.matricolaContatoreCaseFirstStep
            }
          }
        }
        else {
          queryObject = {
            query: GET_CONTRACT,
            variables: {
              integraContractCode: values.codiceContratto,
              invoiceNumber: values.numeroFattura,
            }
          }
        }
        await new Promise((resolve, reject) => {
          client()
            .query(queryObject)
            .then(({ data }) => {
              const {
                integraClientCode,
                accountHolder,
                puf,
                contacts,
                status,
                metreSerialNumber,
              } = data.searchContract;

            if (status.code === "FC00") {
              setErrors({ codiceContratto: codiceContratto.inactiveErrorMsg });
              reject();
            } else {
              // step 1.2
              setFieldValue("comune", puf.city);
              setFieldValue("via", `${puf.street}, ${puf.streetNumber}`);
              setFieldValue("codicePrecedenteUtente", integraClientCode);
              setFieldValue("matricolaContatore", metreSerialNumber);
              // step 4.2
              setFieldValue("codiceUtente", integraClientCode);
              setFieldValue("nomeCognome", accountHolder.businessName);
              setFieldValue(
                "recapitoBolletta",
                `${contacts.address.city}, ${puf.street} ${puf.streetNumber}`
              );
              // step 3.1 mortis causa
              setFieldValue("cityMortisCausa", puf.city);
              setFieldValue("streetMortisCausa", `${puf.street}, ${puf.streetNumber}`);
              // step 4.3
              setFieldValue("datiCatastaliComuneAmministrativo", puf.city);
              setFieldValue("datiCatastaliIndirizzo", puf.street);
              setFieldValue("datiCatastaliNumeroCivico", puf.streetNumber);
              setFieldValue("datiCatastaliProvincia", puf.province);
              setFieldValue("datiCatastaliProvinciaCatastale", puf.province);
              setFieldValue("datiCatastaliComuneCatastale", puf.city);
              resolve();
            }
          })
          .catch((error) => {
            if (buttonMatricolaContatoreCase) {
              setErrors({
                matricolaContatoreCaseFirstStep: matricolaContatoreCaseFirstStep.invalidErrorMsg,
              });
            }
            else {
              setErrors({
                codiceContratto: codiceContratto.invalidErrorMsg,
                numeroFattura: numeroFattura.invalidErrorMsg,
              });
            }
            reject(error);
          });
      });
    },
    fields: [
      {
        fieldName: "codiceContratto",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "numeroFattura",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "matricolaContatoreCaseFirstStep",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "volturaMortisCausa",
        grid: {
          xs: 12,
          md: 12,
        },
        summaryCondition : false,
        className: "voltura-mortis-causa-checkbox"
      },
    ],
  },
  // step 1.2
  {
    chapter: false,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.inoltro_richiesta.title_2" />
    ),
    fields: [
      {
        fieldName: "comune",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "via",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "codicePrecedenteUtente",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "matricolaContatore",
        grid: {
          xs: 12,
          md: 6,
        },
      },
    ],
  },
  // step 1.3
  {
    chapter: false,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.inoltro_richiesta.title_3" />
    ),
    fields: [
      {
        fieldName: "tipoIntestatario",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "fisicaNome",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaCognome",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaCodiceFiscale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaNatoA",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaDataNascita",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaSesso",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaVia",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaComuneResidenza",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaProvincia",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaCAP",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "giuridicaRagioneSociale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaCodiceFiscale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaPartitaIVA",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: false,
          }
        ],
      },
      {
        fieldName: "giuridicaPartitaIVA2",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },
      {
        fieldName: "giuridicaPartitaIVAGrupoCheckbox",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
        className: "align-self-center"
      },
      {
        fieldName: "giuridicaPartitaIVAGrupo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },
      {
        fieldName: null,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },

      {
        fieldName: "giuridicaNome",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaCognome",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaIndirizzo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaSedeLegaleComune",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaProvincia",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaCAP",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
    ],
  },
  // step 2.1
  {
    chapter: true,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.fatturazione_electronica.chapter_name" />
    ),
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.fatturazione_electronica.title_1" />
    ),
    component: VolturaFatturazioneElettronica,
    fields: [
      {
        fieldName: "codiceDestinatarioSDI",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: null,
            is: UserRoleEnum.PRIVATE,
          },
          {
            if: null,
            is: UserRoleEnum.COMPANY,
          },
          {
            if: null,
            is: UserRoleEnum.CONDOMINIUM_ADMIN,
          },
          {
            if: null,
            is: UserRoleEnum.MANAGER,
          },
          {
            if: null,
            is: UserRoleEnum.OPERATOR,
          },
          {
            if: null,
            is: UserRoleEnum.PARTNER,
          },
          {
            if: null,
            is: UserRoleEnum.MUNICIPAL_OPERATOR,
          },
        ],
      },
      {
        fieldName: "codiceDestinatarioPA",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER,
          },
        ],
      },
      {
        fieldName: "indirizzoPEC",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "codiceCIG",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER,
          },
        ],
      },
      {
        fieldName: "codiceCUP",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER,
          },
        ],
      },
      {
        fieldName: "splitPaymentCat",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER,
          },
        ],
      },
    ],
  },
  // step 3.1
  {
    chapter: true,
    hooks: {
      pre: (values, setFieldValue) => {
        if (values[tipoIntestatario.name] === PersonType.NATURAL) {
          setFieldValue(
            "bollettaDatiIntestatario",
            getStandardAddressFormat(
              "cases.address_suggestion.button_2",
              values[fisicaComuneResidenza.name],
              values[fisicaProvincia.name],
              values[fisicaCAP.name],
              values[fisicaVia.name]
            )
          );
        } else {
          setFieldValue(
            "bollettaDatiIntestatario",
            getStandardAddressFormat(
              "cases.address_suggestion.button_2",
              values[giuridicaSedeLegaleComune.name],
              values[giuridicaProvincia.name],
              values[giuridicaCAP.name],
              values[giuridicaIndirizzo.name]
            )
          );
        }
      },
    },
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.bolletta_comunicazioni.chapter_name" />
    ),
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.bolletta_comunicazioni.title_1" />
    ),
    component: DigitalizzazioneDocument,
    fields: [
      {
        fieldName: "bollettaRecapitoTipo",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      // New Address
      {
        fieldName: "bollettaRecapitoNuovoIndirizzo",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      // Existing address
      {
        fieldName: "bollettaPuntoDiFurnitura",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaDatiIntestatario",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaIndirizzo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaComune",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaCap",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaProvincia",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaNomePresso",
        grid: {
          xs: 12,
          md: 6
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
        className: "padding-50",
      }, {
        fieldName: "bollettaCognomePresso",
        grid: {
          xs: 12,
          md: 6
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
        className: "padding-50",
      },
      {
        fieldName: "bollettaCellulare",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaFisso",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaEmail",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaConfirmEmail",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
          (() => {
            const obj = {
              if: "sign",
            };
            Object.defineProperty(obj, "is", {
              get: function () {
                return sign;
              },
            });
            return obj;
          })(),
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={<TranslatedText i18nKey="cases.confirm.email.info" />}
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
          (() => {
            const obj = {
              if: "sign",
            };
            Object.defineProperty(obj, "is", {
              get: function () {
                return sign;
              },
            });
            return obj;
          })(),
        ],
      },
      {
        fieldName: "bollettaPec",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.PRE_ESISTENTE,
          },
        ],
      },
      {
        fieldName: "bollettaIndirizzo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaComune",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaCap",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaProvincia",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaNomePresso",
        grid: {
          xs: 12,
          md: 6
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
        className: "padding-50",
      }, {
        fieldName: "bollettaCognomePresso",
        grid: {
          xs: 12,
          md: 6
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
        className: "padding-50",
      },
      {
        fieldName: "bollettaCellulare",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaFisso",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaEmail",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
      {
        fieldName: "bollettaConfirmEmail",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
          (() => {
            const obj = {
              if: "sign",
            };
            Object.defineProperty(obj, "is", {
              get: function () {
                return sign;
              },
            });
            return obj;
          })(),
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={<TranslatedText i18nKey="cases.confirm.email.info" />}
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
          (() => {
            const obj = {
              if: "sign",
            };
            Object.defineProperty(obj, "is", {
              get: function () {
                return sign;
              },
            });
            return obj;
          })(),
        ],
      },
      {
        fieldName: "bollettaPec",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "bollettaRecapitoTipo",
            is: TipoBollettaRecapito.NUOVO,
          },
        ],
      },
    ],
  },
  // step 4.1
  {
    chapter: true,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.dati_intestatario.chapter_name" />
    ),
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.dati_intestatario.title_1" />
    ),
    fields: [
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.property_declaration.label" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "inQualitaDi",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.ownership_details" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.dichiarazione_sostitutiva" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "ilSottoscrittoNome",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "ilSottoscrittoCognome",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      // {
      //   fieldName: "holderOther",
      //   grid: {
      //     xs: 12,
      //     md: 6,
      //   },
      //   condition: [
      //     {
      //       if: "inQualitaDi",
      //       is: AccountHolderType.OTHER,
      //     },
      //   ],
      // },
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.declaration_request" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
      },
      {
        fieldName: "ownerStatus",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
        className: "align-self-start checkbox-group-list",
      },
      {
        fieldName: "registeredNumber",
        grid: {
          xs: 10,
          md: 2,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
        className: "align-self-start inline-input step-4-3",
      },
      {
        fieldName: null,
        text: (
          <SimpleText text={<TranslatedText i18nKey="common.text.del" />} />
        ),
        grid: {
          xs: 2,
          md: 1,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
        className: "align-self-start mb-3 text-center",
      },
      {
        fieldName: "registeredDate",
        grid: {
          xs: 12,
          md: 3,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OWNER,
          },
        ],
        className: "align-self-start inline-input step-4-3",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.data_possesso_immobile.step4_1" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: 4,
        },
        className: "align-self-start",
      },
      {
        fieldName: "dataPossessoImmobile",
        grid: {
          xs: 12,
          md: 6,
        },
        className: "align-self-start",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.lettura_possesso_immobile.step4_1" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: 3,
        },
        className: "align-self-start",
      },
      {
        fieldName: "letturaPossessoImmobile",
        grid: {
          xs: 12,
          md: 6,
        },
        className: "align-self-start px-4 px-xl-2",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.voltura.step_4.presa_idrica" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: 4,
        },
        // className: 'align-self-start sub-text'
      },
      {
        fieldName: "presaIdrica",
        grid: {
          xs: 12,
          md: 8,
        },
        className: 'radio-button-group'
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.allacciamento.step5_1.non_domestico.altro.label" />
            }
          />
        ),
        grid: {
          xs: 3,
          md: 1,
        },
        className: "align-self-start",
      },
      {
        fieldName: "ownerOtherInsert",
        grid: {
          xs: "auto",
        },
        className: "align-self-start px-4 px-xl-2",
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.titles.labels.affituario" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.TENANT,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.titles.labels.building_administrator" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.CONDOMINIUM_ADMIN,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.titles.labels.usufruttuario" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.USUFRUCTUARY,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.titles.labels.legal_representative" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.LEGAL_REPRESENTATIVE,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.titles.labels.other" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "inQualitaDi",
            is: AccountHolderType.OTHER,
          },
        ],
      },
      {
        fieldName: null,
        text: <h2 className="case-step-title">Decorrenza</h2>,
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "dataDecorrenza",
        grid: {
          xs: 12,
          md: 4,
        },
      },
      {
        fieldName: "letturaDecorrenza",
        grid: {
          xs: 12,
          md: 7,
        },
      },
    ],
  },
  // 3.1 Mortis Causa
  {
    chapter: true,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.dati_intestatario.chapter_name" />
    ),
    title: (
      <TranslatedText i18nKey="cases.voltura.mortis.causa.layout.dati_intestatario.title_1" />
    ),
    fields: [
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.property_declaration.label" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "inQualitaDiMortisCausa",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.dichiarazione_sostitutiva" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "ilSottoscrittoNomeMortisCausa",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "ilSottoscrittoCognomeMortisCausa",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: null,
        text: (
          <PlainLabel
            label={
              <TranslatedText i18nKey="cases.voltura.labels.declaration_request" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "soleHeirStatusMortisCausa",
        grid: {
          xs: 6,
          md: 12,
        },
        className: "align-self-start",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.voltura.labels.intestatario" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: "auto",
        },
        className: "align-self-start",
      },
      {
        fieldName: "ownerMortisCausa",
        grid: {
          xs: 12,
          md: 5,
        },
        className: "align-self-start",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.voltura.labels.deceduto" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: "auto",
        },
        className: "align-self-start",
      },
      {
        fieldName: "dateOwnerMortisCausa",
        grid: {
          xs: 12,
          md: 3,
        },
        className: "align-self-start",
      },
      {
        fieldName: null,
        text: (
          <SimpleText
            text={
              <TranslatedText i18nKey="cases.voltura.labels.inQualitaDi" />
            }
          />
        ),
        grid: {
          xs: 12,
          md: 2,
        },
        className: "align-self-start",
      },
      {
        fieldName: "degreeOfKinship",
        grid: {
          xs: 12,
          md: 8,
          lg: 7,
        },
        className: "radio-row",
      },
      {
        fieldName: "degreeOfKinshipOther",
        grid: {
          xs: 12,
          md: 2,
          lg: 3,
        },
        className: "align-self-start",
      },
      {
        fieldName: "supplyContractMortisCausa",
        grid: {
          xs: 12,
          md: 12,
        },
        className: "voltura-mortis-causa-checkbox"
      },
      {
        fieldName: null,
        text: <h2 className="case-step-title" style={{marginTop:"30px"}}>Punto di fornitura</h2>,
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "cityMortisCausa",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "streetMortisCausa",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "dateLastMeterReadingMortisCausa",
        grid: {
          xs: 12,
          md: 4,
        },
      },
      {
        fieldName: null,
        grid: {
          xs: 12,
          md: 1,
        },
      },
      {
        fieldName: "valueMeterReadingMortisCausa",
        grid: {
          xs: 12,
          md: 7,
        },
      },
    ],
  },
 
  // step 4.2
  {
    chapter: false,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.dati_intestatario.title_2" />
    ),
    fields: [
      {
        fieldName: "codiceUtente",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "nomeCognome",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "letturaFinale",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "recapitoBolletta",
        grid: {
          xs: 12,
          md: 6,
        },
      },
    ],
  },
  // step 4.3
  {
    chapter: false,
    chapterName: "",
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.dati_intestatario.title_3" />
    ),
    fields: [
      {
        fieldName: null,
        text: (
          <div className="dati-catastali">
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dati_catastali.ai_sensi" />
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dati_catastali.nel_case" />
            </p>
          </div>
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "tipo",
        grid: {
          xs: 12,
        },
        className: "justify-content-between",
      },
      {
        fieldName: "datiCatastaliComuneAmministrativo",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "datiCatastaliProvincia",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "datiCatastaliComuneCatastale",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: "datiCatastaliProvinciaCatastale",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: "datiCatastaliIndirizzo",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: "datiCatastaliNumeroCivico",
        grid: { xs: 6, md: 3 },
      },
      {
        fieldName: "datiCatastaliEdificio",
        grid: { xs: 12, md: 4 },
      },
      {
        fieldName: "datiCatastaliScala",
        grid: { xs: 12, md: 4 },
      },
      {
        fieldName: "datiCatastaliPiano",
        grid: { xs: 6, md: 2 },
      },
      {
        fieldName: "datiCatastaliAppartamento",
        grid: { xs: 6, md: 2 },
      },
      {
        fieldName: "datiCatastaliCodiceComuneCatastale",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: "datiCatastaliSezioneUrbana",
        grid: { xs: 12, md: 4 },
      },
      {
        fieldName: "datiCatastaliComuneFoglio",
        grid: { xs: 6, md: 2 },
      },
      {
        fieldName: "datiCatastaliParticella",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: "datiCatastaliSubalterno",
        grid: { xs: 12, md: 6 },
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.layout.dati_catastali.il_comune" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
      },
    ],
  },
  // step 5.1
  {
    chapter: true,
    chapterName: "",
    title: <TranslatedText i18nKey="cases.allacciamento.step5_1.title" />,
    fields: [
      {
        fieldName: "tipologiaUso",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "tipologiaUsoDomestica",
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.DOMESTICO,
          },
        ],
      },

      {
        fieldName: "tipologiaUsoNonDomestica",
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
        ],
      },
      {
        fieldName: "numeroResidenti",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.DOMESTICO,
          },
          {
            if: "tipologiaUsoDomestica",
            is: AreaClassification.RESIDENT_DOMESTIC_USE,
          },
        ],
      },
      {
        fieldName: "residentialUnits",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.DOMESTICO,
          },
          {
            if: "tipologiaUsoDomestica",
            is: AreaClassification.CONDOMINIUM_USE,
          },
        ],
      },
      {
        fieldName: "housingUnits",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.DOMESTICO,
          },
          {
            if: "tipologiaUsoDomestica",
            is: AreaClassification.CONDOMINIUM_USE,
          },
        ],
      },
      {
        fieldName: "notResidentialUnits",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.DOMESTICO,
          },
          {
            if: "tipologiaUsoDomestica",
            is: AreaClassification.CONDOMINIUM_USE,
          },
        ],
      },
      {
        fieldName: "case_2",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
        ],
      },
      {
        fieldName: "case_2_1",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "ISTITUTI_SCOLASTICI",
          },
        ],
      },
      {
        fieldName: "case_2_2",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA",
          },
        ],
      },
      {
        fieldName: "case_2_3",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "CASE_DI_CURA_E_DI_ASSISTENZA",
          },
        ],
      },
      {
        fieldName: "case_2_4",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "OSPEDALI_E_STRUTTURE_OSPEDALIERE",
          },
        ],
      },
      {
        fieldName: "case_3",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "PRESE_ANTINCENDIO",
          },
        ],
      },
      {
        fieldName: "areraClassificationOther",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUsoDomestica",
            is: AreaClassification.OTHER_USE,
          },
        ],
      },
      {
        fieldName: null,
        text: <InfoLabel label={<TranslatedText i18nKey="cases.prese.digitalization" />} />,
        grid: {
          xs: 12,
        },
        condition: [{
          if: 'case_3',
          is: "PRESA_ANTINCENDIO_CON_CONTATORE"
        }],
      },
      {
        fieldName: "case_3_1",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.PUBLIC,
          },
          {
            if: "case_2",
            is: "ALTRO",
          },
        ],
      },
      {
        fieldName: "case_5",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          },
        ],
      },
      {
        fieldName: "case_6",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          },
        ],
      },
      {
        fieldName: "case_7",
        grid: {
          xs: 6,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.INDUSTRIAL_USE,
          },
        ],
      },
      {
        fieldName: "case_4",
        grid: {
          xs: 7,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.OTHER,
          },
        ],
      },
      {
        fieldName: "case_4_1",
        grid: {
          xs: 5,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.OTHER,
          },
          {
            if: "case_4",
            is: "USO_DIVERSO",
          },
        ],
      },
      {
        fieldName: "case_4_2",
        grid: {
          xs: 5,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.OTHER,
          },
          {
            if: "case_4",
            is: "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE",
          },
        ],
      },
      {
        fieldName: "case_4_3",
        grid: {
          xs: 5,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.OTHER,
          },
          {
            if: "case_4",
            is: "USO_IRRIGUO_E_COLLETTIVO",
          },
        ],
      },

      {
        fieldName: "notDomesticUseActivity",
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "tipologiaUso",
            is: TipologiaUsoFornitura.NON_DOMESTICO,
          },
        ],
        className: "tipologiaDiAttivita",
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.layout.tipologia_uso" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: (_values) => {
          return _values["tipologiaUso"] === TipologiaUsoFornitura.DOMESTICO && _values["tipologiaUsoDomestica"] !== AreaClassification.OTHER_USE;
        },
      },
      {
        fieldName: "tipologiaIntestatario",
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE,
          },
        ],
        className: "px-5 px-md-4",
      },
      {
        fieldName: "tipologiaIntestatario",
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: "tipologiaUsoNonDomestica",
            is: AreaClassification.ARTISAN_AND_COMMERCIAL_USE,
          },
        ],
        className: "px-5 px-md-4",
      }
    ],
  },
  // step 5.2
  {
    chapter: false,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.chapter_name" />
    ),
    noMandatoryLegend: true,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.title_1" />
    ),
    fieldcondition: [
      "volturaMortisCausa",
      "signValue",
    ],
    fields: [
      {
        fieldName: null,
        text: (
          <div className="declaration">
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_1" />
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_2" />
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_3" />
            </p>
          </div>
        ),
        condition: [
          {
            if: 'volturaMortisCausa',
            is: false,
          },
        ],
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: null,
        text: (
          <div className="declaration">
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_1_mortis_causa"/>
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_2_mortis_causa"/>
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_3_mortis_causa"/>
            </p>
          </div>
        ),
        condition: [
          {
            if: 'volturaMortisCausa',
            is: true,
          },
        ],
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "estremiDelDocumento1",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: 'signValue',
            is: false,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <InfoLabel
            label={
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
            }
          />
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: 'signValue',
            is: false,
          },
        ],

      },      
      {
        fieldName: null,
        text: (
          <h2 className="case-step-title">
            <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.title" />
          </h2>
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: 'volturaMortisCausa',
            is: false,
          },
        ],
      },
      {
        fieldName: null,
        text: (
          <p className="conditions">
            <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.description" />
          </p>
        ),
        grid: {
          xs: 12,
        },
        condition: [
          {
            if: 'volturaMortisCausa',
            is: false,
          },
        ],
      }      
    ],
  },
  // step 6.1
  {
    chapter: true,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.bolleta_online.chpater_name" />
    ),
    noMandatoryLegend: true,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.bolleta_online.title_1" />
    ),
    fields: [
      {
        fieldName: "bollettaOnlineAttiva",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: null,
        text: (
          <p className="checkbox-sub-text">
            <TranslatedText i18nKey="cases.voltura.layout.bolleta_online.sub_text" />
          </p>
        ),
        grid: {
          xs: 12,
        },
      },
    ],
  },
  // step 7.1
  {
    chapter: true,
    chapterName: (
      <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.chapter_name" />
    ),
    noMandatoryLegend: true,
    title: (
      <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.title" />
    ),
    // beforeSubmit: async (values, { setFieldValue, setErrors }) => {
    //   if(values.bollettaAddebitoBancario) {
    //     await new Promise((resolve, reject) => {
    //       client()
    //         .query({
    //           query: GET_IBAN_VALIDATION,
    //           variables: {
    //             iban: values.iban,
    //           },
    //           fetchPolicy: "network-only",
    //         })
    //         .then(result => {
    //           return result;
    //         })
    //         .then(result => {
    //           if(result && result.data && result.data.ibanCheck && result.data.ibanCheck.outcome && result.data.ibanCheck.outcome==="success"){

      //             setFieldValue("bankName", result.data.ibanCheck.details.bank )
      //             setFieldValue("agencia", result.data.ibanCheck.details.branch )
      //             setTimeout(()=>{
      //               resolve(result);
      //             },1000)
      //           }
      //           else{
      //             setErrors({ iban: iban.requiredErrorMsg });
      //             reject();
      //           }
      //         })
      //         .catch(error => {
      //           const errors = standardizeGraphQLError(error);
      //           setErrors({ iban: <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_error" /> });
      //           reject(errors);
      //         })
      //     });
      //   }

      // },
      fields: [
        {
          fieldName: "bollettaAddebitoBancario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="checkbox-sub-text">
              <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.sub_text" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend" /></p>
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cognomeNomeDelConto",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleTitolare",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },

        {
          fieldName: "indirizzoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cellulareDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "telefonoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "bankName",
          grid: {
            xs: 12,
            md: 8,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "agencia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "iban",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
      ],
    },
    // step 8.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.voltura.layout.informativa_privacy.chapter_name" />
      ),
      noMandatoryLegend: true,
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.informativa_privacy.title" />
      ),
      fields: [

        {
          fieldName: null,
          text: (
            <div className="information-privacy">
              <p>
                <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
              </p>
            </div>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },

    // step 9
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.digitalization.title" />,
      title: <TranslatedText i18nKey="cases.digitalization.title" />,
      fields: [
        {
          fieldName: "estremiDelDocumento",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: signValue,
              is: false,
            }
          ],

        },
        {
          fieldName: "idType",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "IdType",
              is: ""
            }
          ]
        },
        {
          fieldName: "ID",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence"
          }

        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return (_values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence") &&
              (_values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER || _values["inQualitaDiMortisCausa"] === AccountHolderType.TENANT || _values["inQualitaDiMortisCausa"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDiMortisCausa"] === AccountHolderType.OTHER);
          }

        },
        {
          fieldName: "Legittima",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER || _values["inQualitaDiMortisCausa"] === AccountHolderType.TENANT || _values["inQualitaDiMortisCausa"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDiMortisCausa"] === AccountHolderType.OTHER;
          }
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleDoc",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "verbale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            }]
        },
        {
          fieldName: "CCIAA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "case_2",
              is: "PRESE_ANTINCENDIO",
            },
          ],
        },
        {
          fieldName: "dichiarazione",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "case_2",
              is: "PRESE_ANTINCENDIO",
            },
          ],
        },
      ],
    },
  ]
}

// Contiene dettagli sul case form
const getFormDetails = (digitalization = null) => {
  const pdfLink = getCorrectLink(casesInfoVoltura);
  return {
    title: <TranslatedText i18nKey="cases.voltura.title" />,
    description: digitalization ? (<TranslatedText i18nKey="cases.voltura.help_text" />) : (
      <a
        className="link-a"
        href={pdfLink}
        target={"_blank"}
        rel="noopener noreferrer"
      >
        <span
          className="gc-icon-functional-doc-pdf-2-col"
          style={{ verticalAlign: "bottom" }}
        >
          <span className="path1" />
          <span className="path2" />
        </span>{" "}
        {<TranslatedText i18nKey="cases.voltura.description.info" />}
      </a>
    ),
    summary: true,
    stepper: CaseStepperType.Full,
    helpText: digitalization ? null : (
      <>
        <TranslatedText i18nKey="cases.voltura.help_text" />
        <br />
        <>
          {sign ? (
            <TranslatedText i18nKey="cases.voltura.help_text_1_digitalization" />
          ) : (
            <TranslatedText i18nKey="cases.voltura.help_text_1" />
          )}
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href={`mailto:contratti@gruppocap.it`}
          >
            contratti@gruppocap.it
          </a>{" "}
          <br />
          <TranslatedText i18nKey="cases.voltura.help_text_2" />
        </>
      </>
    ),
    successText: (
      <>
        <p>
          <TranslatedText i18nKey="cases.voltura.success_text_1" />{" "}
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href={`mailto:contratti@gruppocap.it`}
          >
            contratti@gruppocap.it
          </a>{" "}
          <TranslatedText i18nKey="cases.voltura.success_text_3" />
        </p>
      </>
    ),
    incompleteActivation: true,
    autoOpenHelpModal: digitalization ? false : true,
  };
};

const mutation = {
  type: CaseMutationType.Complex,
};
const punctualizationMapping = (payload) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const DOMESTIC = payload[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO;
  let usagetypeAreraClassification;
  let subtypeArera;
  if (payload[case_2.name] === "PRESE_ANTINCENDIO") {
    usagetypeAreraClassification = payload[case_3.name];
  } else if (payload[case_2.name] === "ALTRO") {
    usagetypeAreraClassification = payload[case_3_1.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE
  ) {
    usagetypeAreraClassification = payload[case_5.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.ARTISAN_AND_COMMERCIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_6.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.INDUSTRIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_7.name];
  } else if (payload[case_4.name] === "USO_DIVERSO") {
    usagetypeAreraClassification = payload[case_4_1.name];
  } else if (
    payload[case_4.name] === "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE"
  ) {
    usagetypeAreraClassification = payload[case_4_2.name];
  } else if (payload[case_4.name] === "USO_IRRIGUO_E_COLLETTIVO") {
    usagetypeAreraClassification = payload[case_4_3.name];
  } else if (payload[case_2.name] === "ISTITUTI_SCOLASTICI") {
    usagetypeAreraClassification = payload[case_2_1.name];
  } else if (
    payload[case_2.name] === "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA"
  ) {
    usagetypeAreraClassification = payload[case_2_2.name];
  } else if (payload[case_2.name] === "CASE_DI_CURA_E_DI_ASSISTENZA") {
    usagetypeAreraClassification = payload[case_2_3.name];
  } else if (payload[case_2.name] === "OSPEDALI_E_STRUTTURE_OSPEDALIERE") {
    usagetypeAreraClassification = payload[case_2_4.name];
  }

  if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC) {
    subtypeArera = payload[case_2.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.OTHER
  ) {
    subtypeArera = payload[case_4.name];
  }
  return {
    toSign: false,
    // attachments: [
    //   payload[inQualitaDi.name] !== AccountHolderType.OWNER ? ({
    //     data: payload[Legittima.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
    //     data: payload[codiceFiscaleDoc.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
    //     data: payload[verbale.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.LEGAL_REPRESENTATIVE ? ({
    //     data: payload[CCIAA.name]
    //   }): null,
    //   payload[case_2.name] === 'PRESE_ANTINCENDIO' ?({
    //     data: payload[dichiarazione.name]
    //   }) : null,
    //   {
    //     data: payload[ID.name]
    //   },
    // ],
    accountHolder: {
      address: {
        city: NATURAL
          ? payload[fisicaComuneResidenza.name]
          : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL
          ? payload[fisicaCAP.name]
          : payload[giuridicaCAP.name],
        province: NATURAL
          ? payload[fisicaProvincia.name]
          : payload[giuridicaProvincia.name],
        street: NATURAL
          ? payload[fisicaVia.name].split(",")[0] || ""
          : payload[giuridicaIndirizzo.name].split(",")[0] || "",
        streetNumber: NATURAL
          ? payload[fisicaVia.name].split(",")[1] || ""
          : payload[giuridicaIndirizzo.name].split(",")[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      billing: {
        cigCode: payload[codiceCIG.name],
        cupCode: payload[codiceCUP.name],
        paCode: payload[codiceDestinatarioPA.name],
        pec: payload[indirizzoPEC.name],
        sdiCode: payload[codiceDestinatarioSDI.name],
        splitPaymentCat: payload[splitPaymentCat.name],
      },
      birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy"),
      birthPlace: payload[fisicaNatoA.name],
      businessName: payload[giuridicaRagioneSociale.name],

      contactsInfo: {
        addressRecapito: {
          city: payload[bollettaComune.name],
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
          postalCode: payload[bollettaCap.name],
          province: payload[bollettaProvincia.name],
          street: payload[bollettaIndirizzo.name].split(",")[0] || "",
          streetNumber: payload[bollettaIndirizzo.name].split(",")[1] || "",
        },
        email: payload[bollettaEmail.name],
        ...(payload[bollettaFisso.name] && {
          landlinePhoneNumber: payload[bollettaFisso.name],
        }),
        mobilePhoneNumber: payload[bollettaCellulare.name],
        pec: payload[bollettaPec.name],
      },
      fiscalCode: NATURAL
        ? payload[fisicaCodiceFiscale.name]
        : payload[giuridicaCodiceFiscale.name],
      holderOther: payload[holderOther.name],
      holderType: payload[inQualitaDi.name],
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaNome.name],
      personType: payload[tipoIntestatario.name],
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      surname: NATURAL
        ? payload[fisicaCognome.name]
        : payload[giuridicaCognome.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      address: payload[indirizzoDomiciliazione.name],
      bankBranch: payload[agencia.name],
      bankName: payload[bankName.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      iban: payload[iban.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      owner: payload[cognomeNomeDelConto.name],
    },
    cadastre: {
      administrativeUnit: payload[datiCatastaliComuneAmministrativo.name],
      administrativeUnitProvince: payload[datiCatastaliProvincia.name],
      building: payload[datiCatastaliEdificio.name],
      cadastralLot: payload[datiCatastaliParticella.name],
      cadastralMunicipality: payload[datiCatastaliComuneCatastale.name],
      cadastralMunicipalityCode:
        payload[datiCatastaliCodiceComuneCatastale.name],
      cadastralMunicipalityProvince:
        payload[datiCatastaliProvinciaCatastale.name],
      flat: payload[datiCatastaliAppartamento.name],
      floor: payload[datiCatastaliPiano.name],
      plot: payload[datiCatastaliComuneFoglio.name],
      staircase: payload[datiCatastaliScala.name],
      street: payload[datiCatastaliIndirizzo.name],
      streetNumber: payload[datiCatastaliNumeroCivico.name],
      subDivision: payload[datiCatastaliSubalterno.name],
      type: payload[tipo.name],
      urbanSection: payload[datiCatastaliSezioneUrbana.name],
    },

    oldContract: {
      declaration: {
        acts: [
          {
            type: DeclarationType.OWNER,
            enabled: payload[inQualitaDi.name] === AccountHolderType.OWNER ? true : false,
            number: payload[registeredNumber.name],
            date: moment(payload[registeredDate.name]).format("DD/MM/yyyy"),
          },
          {
            type: DeclarationType.POSSESSION,
            enabled: true,
            from: moment(payload[dataPossessoImmobile.name]).format(
              "DD/MM/yyyy"
            ),
          },
          {
            type: DeclarationType.OTHER,
            note: payload[ownerOtherInsert.name],
            enabled: true,
          },
        ],
        idricOutlet: isRadioBoolean(payload[presaIdrica.name]),
        undersigned:
          `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]
          }` || "",
      },
      domesticUseType: payload[tipologiaUso.name],
      ...(DOMESTIC && {
        areraClassification: payload[tipologiaUsoDomestica.name],
      }),
      ...(!DOMESTIC && {
        areraClassification:
          payload[case_2.name] === "ALTRO" &&
            payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? "PUBLIC_USE_DISALIMENTABILE"
            : payload[case_2.name] !== "ALTRO" &&
              payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.PUBLIC
              ? "PUBLIC_USE_NOT_DISALIMENTABILE"
              : payload[tipologiaUsoNonDomestica.name],
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.RESIDENT_DOMESTIC_USE && {
        residentNumber: Number(payload[numeroResidenti.name]),
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        residentialUnits: Number(payload[residentialUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        housingUnits: Number(payload[housingUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        notResidentialUnits: Number(payload[notResidentialUnits.name]),
      }),

      ...(!DOMESTIC && {
        notDomesticUseDetails: payload[tipologiaUsoNonDomestica.name],
      }),

      ...(!DOMESTIC && {
        notDomesticUseActivity: payload[notDomesticUseActivity.name],
      }),
      ...(!DOMESTIC && { subtypeAreraClassification: subtypeArera }),
      ...(payload[tipologiaUsoDomestica.name] !==
        AreaClassification.RESIDENT_DOMESTIC_USE &&
        payload[tipologiaUsoDomestica.name] !== AreaClassification.NOT_RESIDENT_DOMESTIC_USE && {
        subtypeAreraClassification:
          payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? payload[case_2.name]
            : payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.OTHER
              ? payload[case_4.name]
              : "",
        usagetypeAreraClassification: usagetypeAreraClassification,
      }),
      identityCardCode: payload[estremiDelDocumento1.name],
      integraContractCode: payload[codiceContratto.name],
      metreSerialNumber: payload[matricolaContatoreCaseFirstStep.name],
      invoiceNumber: payload[numeroFattura.name],
      onlineBill: {
        enabled: payload[bollettaOnlineAttiva.name],
      },
      lastReading: {
        date: moment(payload[dataDecorrenza.name]).format("DD/MM/yyyy"),
        value: Number(payload[letturaDecorrenza.name]),
      },
      finalReading: {
        value: Number(payload[letturaFinale.name]),
      },
      selfReading: payload[letturaPossessoImmobile.name],
      owner: payload[tipologiaIntestatario.name]
        ? payload[tipologiaIntestatario.name]
        : null,
    },
    addressList : [
      NATURAL ? model.formField.fisicaVia.egonCodeResponse :  model.formField.giuridicaIndirizzo.egonCodeResponse,
      model.formField.bollettaIndirizzo.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: ComplexCaseType.REG_TRANSFER,
  };
};

const translatedMapping = (payload, excludeProperties) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const DOMESTIC =
    payload[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO;
  let subtypeArera;
  if (excludeProperties) {
    return punctualizationMapping(payload);
  }
  let usagetypeAreraClassification;
  if (payload[case_2.name] === "PRESE_ANTINCENDIO") {
    usagetypeAreraClassification = payload[case_3.name];
  } else if (payload[case_2.name] === "ALTRO") {
    usagetypeAreraClassification = payload[case_3_1.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE
  ) {
    usagetypeAreraClassification = payload[case_5.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.ARTISAN_AND_COMMERCIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_6.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.INDUSTRIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_7.name];
  } else if (payload[case_4.name] === "USO_DIVERSO") {
    usagetypeAreraClassification = payload[case_4_1.name];
  } else if (
    payload[case_4.name] === "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE"
  ) {
    usagetypeAreraClassification = payload[case_4_2.name];
  } else if (payload[case_4.name] === "USO_IRRIGUO_E_COLLETTIVO") {
    usagetypeAreraClassification = payload[case_4_3.name];
  } else if (payload[case_2.name] === "ISTITUTI_SCOLASTICI") {
    usagetypeAreraClassification = payload[case_2_1.name];
  } else if (
    payload[case_2.name] === "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA"
  ) {
    usagetypeAreraClassification = payload[case_2_2.name];
  } else if (payload[case_2.name] === "CASE_DI_CURA_E_DI_ASSISTENZA") {
    usagetypeAreraClassification = payload[case_2_3.name];
  } else if (payload[case_2.name] === "OSPEDALI_E_STRUTTURE_OSPEDALIERE") {
    usagetypeAreraClassification = payload[case_2_4.name];
  }

  if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC) {
    subtypeArera = payload[case_2.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.OTHER
  ) {
    subtypeArera = payload[case_4.name];
  }
  return {
    toSign: true,
    attachments: [
      payload[inQualitaDi.name] !== AccountHolderType.OWNER
        ? {
          data: payload[Legittima.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[codiceFiscaleDoc.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[verbale.name],
        }
        : null,
      payload[inQualitaDi.name] === AccountHolderType.LEGAL_REPRESENTATIVE
        ? {
          data: payload[CCIAA.name],
        }
        : null,
      payload[case_2.name] === "PRESE_ANTINCENDIO"
        ? {
          data: payload[dichiarazione.name],
        }
        : null,
      {
        data: payload[ID.name],
      },
    ],
    accountHolder: {
      address: {
        city: NATURAL
          ? payload[fisicaComuneResidenza.name]
          : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL
          ? payload[fisicaCAP.name]
          : payload[giuridicaCAP.name],
        province: NATURAL
          ? payload[fisicaProvincia.name]
          : payload[giuridicaProvincia.name],
        street: NATURAL
          ? payload[fisicaVia.name].split(",")[0] || ""
          : payload[giuridicaIndirizzo.name].split(",")[0] || "",
        streetNumber: NATURAL
          ? payload[fisicaVia.name].split(",")[1] || ""
          : payload[giuridicaIndirizzo.name].split(",")[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      billing: {
        cigCode: payload[codiceCIG.name],
        cupCode: payload[codiceCUP.name],
        paCode: payload[codiceDestinatarioPA.name],
        pec: payload[indirizzoPEC.name],
        sdiCode: payload[codiceDestinatarioSDI.name],
        splitPaymentCat: payload[splitPaymentCat.name],
      },
      birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy"),
      birthPlace: payload[fisicaNatoA.name],
      businessName: payload[giuridicaRagioneSociale.name],

      contactsInfo: {
        addressRecapito: {
          city: payload[bollettaComune.name],
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
          postalCode: payload[bollettaCap.name],
          province: payload[bollettaProvincia.name],
          street: payload[bollettaIndirizzo.name].split(",")[0] || "",
          streetNumber: payload[bollettaIndirizzo.name].split(",")[1] || "",
        },
        email: payload[bollettaEmail.name],
        ...(payload[bollettaFisso.name] && {
          landlinePhoneNumber: payload[bollettaFisso.name],
        }),
        mobilePhoneNumber: payload[bollettaCellulare.name],
        pec: payload[bollettaPec.name],
      },
      fiscalCode: NATURAL
        ? payload[fisicaCodiceFiscale.name]
        : payload[giuridicaCodiceFiscale.name],
      holderOther: payload[holderOther.name],
      holderType: payload[inQualitaDi.name],
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaNome.name],
      personType: payload[tipoIntestatario.name],
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      surname: NATURAL
        ? payload[fisicaCognome.name]
        : payload[giuridicaCognome.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      address: payload[indirizzoDomiciliazione.name],
      bankBranch: payload[agencia.name],
      bankName: payload[bankName.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      iban: payload[iban.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      owner: payload[cognomeNomeDelConto.name],
    },
    cadastre: {
      administrativeUnit: payload[datiCatastaliComuneAmministrativo.name],
      administrativeUnitProvince: payload[datiCatastaliProvincia.name],
      building: payload[datiCatastaliEdificio.name],
      cadastralLot: payload[datiCatastaliParticella.name],
      cadastralMunicipality: payload[datiCatastaliComuneCatastale.name],
      cadastralMunicipalityCode:
        payload[datiCatastaliCodiceComuneCatastale.name],
      cadastralMunicipalityProvince:
        payload[datiCatastaliProvinciaCatastale.name],
      flat: payload[datiCatastaliAppartamento.name],
      floor: payload[datiCatastaliPiano.name],
      plot: payload[datiCatastaliComuneFoglio.name],
      staircase: payload[datiCatastaliScala.name],
      street: payload[datiCatastaliIndirizzo.name],
      streetNumber: payload[datiCatastaliNumeroCivico.name],
      subDivision: payload[datiCatastaliSubalterno.name],
      type: payload[tipo.name],
      urbanSection: payload[datiCatastaliSezioneUrbana.name],
    },
    oldContract: {
      declaration: {
        acts: [
          {
            type: DeclarationType.OWNER,
            enabled: payload[ownerStatus.name],
            number: payload[registeredNumber.name],
            date: moment(payload[registeredDate.name]).format("DD/MM/yyyy"),
          },
          {
            type: DeclarationType.POSSESSION,
            enabled: true,
            from: moment(payload[dataPossessoImmobile.name]).format(
              "DD/MM/yyyy"
            ),
          },
          {
            type: DeclarationType.OTHER,
            note: payload[ownerOtherInsert.name],
            enabled: true,
          },
        ],
        idricOutlet: isRadioBoolean(payload[presaIdrica.name]),
        undersigned:
          `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]
          }` || "",
      },
      domesticUseType: payload[tipologiaUso.name],
      ...(DOMESTIC && {
        areraClassification: payload[tipologiaUsoDomestica.name],
      }),
      ...(!DOMESTIC && {
        areraClassification:
          payload[case_2.name] === "ALTRO" &&
            payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? "PUBLIC_USE_DISALIMENTABILE"
            : payload[case_2.name] !== "ALTRO" &&
              payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.PUBLIC
              ? "PUBLIC_USE_NOT_DISALIMENTABILE"
              : payload[tipologiaUsoNonDomestica.name],
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.RESIDENT_DOMESTIC_USE && {
        residentNumber: Number(payload[numeroResidenti.name]),
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        residentialUnits: Number(payload[residentialUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        housingUnits: Number(payload[housingUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        notResidentialUnits: Number(payload[notResidentialUnits.name]),
      }),

      ...(!DOMESTIC && {
        notDomesticUseDetails: payload[tipologiaUsoNonDomestica.name],
      }),

      ...(!DOMESTIC && {
        notDomesticUseActivity: payload[notDomesticUseActivity.name],
      }),
      ...(!DOMESTIC && {
        subtypeAreraClassification:
          payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? payload[case_2.name]
            : payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.OTHER
              ? payload[case_4.name]
              : "",
      }),
      ...(!DOMESTIC && { subtypeAreraClassification: subtypeArera }),
      ...(!DOMESTIC && { usagetypeAreraClassification: usagetypeAreraClassification }),

      identityCardCode: payload[estremiDelDocumento.name],
      integraContractCode: payload[codiceContratto.name],
      metreSerialNumber: payload[matricolaContatoreCaseFirstStep.name],
      invoiceNumber: payload[numeroFattura.name],
      onlineBill: {
        enabled: payload[bollettaOnlineAttiva.name],
      },
      lastReading: {
        date: moment(payload[dataDecorrenza.name]).format("DD/MM/yyyy"),
        value: Number(payload[letturaDecorrenza.name]),
      },
      finalReading: {
        value: Number(payload[letturaFinale.name]),
      },
      selfReading: payload[letturaPossessoImmobile.name],
      owner: payload[tipologiaIntestatario.name]
        ? payload[tipologiaIntestatario.name]
        : null,
    },
    addressList : [
      NATURAL ? model.formField.fisicaVia.egonCodeResponse :  model.formField.giuridicaIndirizzo.egonCodeResponse,
      model.formField.bollettaIndirizzo.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: ComplexCaseType.REG_TRANSFER,
  };
};
const translatedMappingMortisCausa = (payload) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const DOMESTIC =
    payload[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO;
  let subtypeArera;
  let usagetypeAreraClassification;
  if (payload[case_2.name] === "PRESE_ANTINCENDIO") {
    usagetypeAreraClassification = payload[case_3.name];
  } else if (payload[case_2.name] === "ALTRO") {
    usagetypeAreraClassification = payload[case_3_1.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.AGRICULTURAL_AND_ZOOTECHNICAL_USE
  ) {
    usagetypeAreraClassification = payload[case_5.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] ===
    AreaClassification.ARTISAN_AND_COMMERCIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_6.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.INDUSTRIAL_USE
  ) {
    usagetypeAreraClassification = payload[case_7.name];
  } else if (payload[case_4.name] === "USO_DIVERSO") {
    usagetypeAreraClassification = payload[case_4_1.name];
  } else if (
    payload[case_4.name] === "USO_CON_FUNZIONE_DI_UTILITA_PUBBLICA_E_SOCIALE"
  ) {
    usagetypeAreraClassification = payload[case_4_2.name];
  } else if (payload[case_4.name] === "USO_IRRIGUO_E_COLLETTIVO") {
    usagetypeAreraClassification = payload[case_4_3.name];
  } else if (payload[case_2.name] === "ISTITUTI_SCOLASTICI") {
    usagetypeAreraClassification = payload[case_2_1.name];
  } else if (
    payload[case_2.name] === "PRESIDI_OPERATIVI_EMERGENZA_E_SICUREZZA"
  ) {
    usagetypeAreraClassification = payload[case_2_2.name];
  } else if (payload[case_2.name] === "CASE_DI_CURA_E_DI_ASSISTENZA") {
    usagetypeAreraClassification = payload[case_2_3.name];
  } else if (payload[case_2.name] === "OSPEDALI_E_STRUTTURE_OSPEDALIERE") {
    usagetypeAreraClassification = payload[case_2_4.name];
  }

  if (payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC) {
    subtypeArera = payload[case_2.name];
  } else if (
    payload[tipologiaUsoNonDomestica.name] === AreaClassification.OTHER
  ) {
    subtypeArera = payload[case_4.name];
  }
  return {
    toSign: true,
    attachments: [
      payload[inQualitaDiMortisCausa.name] !== AccountHolderType.OWNER
        ? {
          data: payload[Legittima.name],
        }
        : null,
      payload[inQualitaDiMortisCausa.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[codiceFiscaleDoc.name],
        }
        : null,
      payload[inQualitaDiMortisCausa.name] === AccountHolderType.CONDOMINIUM_ADMIN
        ? {
          data: payload[verbale.name],
        }
        : null,
      payload[inQualitaDiMortisCausa.name] === AccountHolderType.LEGAL_REPRESENTATIVE
        ? {
          data: payload[CCIAA.name],
        }
        : null,
      payload[case_2.name] === "PRESE_ANTINCENDIO"
        ? {
          data: payload[dichiarazione.name],
        }
        : null,
      {
        data: payload[ID.name],
      },
    ],
    accountHolder: {
      address: {
        city: NATURAL
          ? payload[fisicaComuneResidenza.name]
          : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL
          ? payload[fisicaCAP.name]
          : payload[giuridicaCAP.name],
        province: NATURAL
          ? payload[fisicaProvincia.name]
          : payload[giuridicaProvincia.name],
        street: NATURAL
          ? payload[fisicaVia.name].split(",")[0] || ""
          : payload[giuridicaIndirizzo.name].split(",")[0] || "",
        streetNumber: NATURAL
          ? payload[fisicaVia.name].split(",")[1] || ""
          : payload[giuridicaIndirizzo.name].split(",")[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      billing: {
        cigCode: payload[codiceCIG.name],
        cupCode: payload[codiceCUP.name],
        paCode: payload[codiceDestinatarioPA.name],
        pec: payload[indirizzoPEC.name],
        sdiCode: payload[codiceDestinatarioSDI.name],
        splitPaymentCat: payload[splitPaymentCat.name],
      },
      birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy"),
      birthPlace: payload[fisicaNatoA.name],
      businessName: payload[giuridicaRagioneSociale.name],

      contactsInfo: {
        addressRecapito: {
          city: payload[bollettaComune.name],
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
          postalCode: payload[bollettaCap.name],
          province: payload[bollettaProvincia.name],
          street: payload[bollettaIndirizzo.name].split(",")[0] || "",
          streetNumber: payload[bollettaIndirizzo.name].split(",")[1] || "",
        },
        email: payload[bollettaEmail.name],
        ...(payload[bollettaFisso.name] && {
          landlinePhoneNumber: payload[bollettaFisso.name],
        }),
        mobilePhoneNumber: payload[bollettaCellulare.name],
        pec: payload[bollettaPec.name],
      },
      fiscalCode: NATURAL
        ? payload[fisicaCodiceFiscale.name]
        : payload[giuridicaCodiceFiscale.name],
      holderOther: payload[holderOther.name],
      holderType: payload[inQualitaDiMortisCausa.name],
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaNome.name],
      personType: payload[tipoIntestatario.name],
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      surname: NATURAL
        ? payload[fisicaCognome.name]
        : payload[giuridicaCognome.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      address: payload[indirizzoDomiciliazione.name],
      bankBranch: payload[agencia.name],
      bankName: payload[bankName.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      iban: payload[iban.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      owner: payload[cognomeNomeDelConto.name],
    },
    cadastre: {
      administrativeUnit: payload[datiCatastaliComuneAmministrativo.name],
      administrativeUnitProvince: payload[datiCatastaliProvincia.name],
      building: payload[datiCatastaliEdificio.name],
      cadastralLot: payload[datiCatastaliParticella.name],
      cadastralMunicipality: payload[datiCatastaliComuneCatastale.name],
      cadastralMunicipalityCode:
        payload[datiCatastaliCodiceComuneCatastale.name],
      cadastralMunicipalityProvince:
        payload[datiCatastaliProvinciaCatastale.name],
      flat: payload[datiCatastaliAppartamento.name],
      floor: payload[datiCatastaliPiano.name],
      plot: payload[datiCatastaliComuneFoglio.name],
      staircase: payload[datiCatastaliScala.name],
      street: payload[datiCatastaliIndirizzo.name],
      streetNumber: payload[datiCatastaliNumeroCivico.name],
      subDivision: payload[datiCatastaliSubalterno.name],
      type: payload[tipo.name],
      urbanSection: payload[datiCatastaliSezioneUrbana.name],
    },
    oldContract: {
      declaration: {
        acts: [
          {
            type: DeclarationType.OWNER,
            enabled: payload[ownerStatus.name],
            number: payload[registeredNumber.name],
            date: moment(payload[registeredDate.name]).format("DD/MM/yyyy"),
          },
          {
            type: DeclarationType.POSSESSION,
            enabled: true,
            from: moment(payload[dataPossessoImmobile.name]).format(
              "DD/MM/yyyy"
            ),
          },
          {
            type: DeclarationType.OTHER,
            note: payload[ownerOtherInsert.name],
            enabled: true,
          },
        ],
        idricOutlet: isRadioBoolean(payload[presaIdrica.name]),
        undersigned:
          `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]
          }` || "",
      },
      domesticUseType: payload[tipologiaUso.name],
      ...(DOMESTIC && payload[tipologiaUsoDomestica.name] !== AreaClassification.OTHER_USE && {
        areraClassification: payload[tipologiaUsoDomestica.name],
      }),
      ...(!DOMESTIC && {
        areraClassification:
          payload[case_2.name] === "ALTRO" &&
            payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? "PUBLIC_USE_DISALIMENTABILE"
            : payload[case_2.name] !== "ALTRO" &&
              payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.PUBLIC
              ? "PUBLIC_USE_NOT_DISALIMENTABILE"
              : payload[tipologiaUsoNonDomestica.name],
      }),
      areraClassificationOther: payload[areraClassificationOther.name],

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.RESIDENT_DOMESTIC_USE && {
        residentNumber: Number(payload[numeroResidenti.name]),
      }),

      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        residentialUnits: Number(payload[residentialUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        housingUnits: Number(payload[housingUnits.name]),
      }),
      ...(DOMESTIC &&
        payload[tipologiaUsoDomestica.name] ===
        AreaClassification.CONDOMINIUM_USE && {
        notResidentialUnits: Number(payload[notResidentialUnits.name]),
      }),

      ...(!DOMESTIC && {
        notDomesticUseDetails: payload[tipologiaUsoNonDomestica.name],
      }),

      ...(!DOMESTIC && {
        notDomesticUseActivity: payload[notDomesticUseActivity.name],
      }),
      ...(!DOMESTIC && {
        subtypeAreraClassification:
          payload[tipologiaUsoNonDomestica.name] === AreaClassification.PUBLIC
            ? payload[case_2.name]
            : payload[tipologiaUsoNonDomestica.name] ===
              AreaClassification.OTHER
              ? payload[case_4.name]
              : "",
      }),
      ...(!DOMESTIC && { subtypeAreraClassification: subtypeArera }),
      ...(!DOMESTIC && { usagetypeAreraClassification: usagetypeAreraClassification }),
      identityCardCode: payload[estremiDelDocumento.name],
      integraContractCode: payload[codiceContratto.name],
      metreSerialNumber: payload[matricolaContatoreCaseFirstStep.name],
      invoiceNumber: payload[numeroFattura.name],
      onlineBill: {
        enabled: payload[bollettaOnlineAttiva.name],
      },
      lastReading: {
        date: moment(payload[dateLastMeterReadingMortisCausa.name]).format("DD/MM/yyyy"),
        value: Number(payload[valueMeterReadingMortisCausa.name]),
      },
      finalReading: {
        value: Number(payload[letturaFinale.name]),
      },
      selfReading: payload[letturaPossessoImmobile.name],
      owner: payload[tipologiaIntestatario.name]
        ? payload[tipologiaIntestatario.name]
        : null,
    },
    addressList : [
      NATURAL ? model.formField.fisicaVia.egonCodeResponse :  model.formField.giuridicaIndirizzo.egonCodeResponse,
      model.formField.bollettaIndirizzo.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    erede : {
      nome : payload[ilSottoscrittoNomeMortisCausa.name],
      cognome: payload[ilSottoscrittoCognomeMortisCausa.name],
      eredeUnico: payload[soleHeirStatusMortisCausa.name] === TypeHeir.SOLE,
      intestatario: payload[ownerMortisCausa.name],
      dataDecesso: moment(payload[dateOwnerMortisCausa.name]).format("DD/MM/yyyy"),
      tipologiaRelazione: payload[degreeOfKinship.name],
      tipologiaRelazioneAltro: payload[degreeOfKinshipOther.name],
      nucleoAgevolato: payload[supplyContractMortisCausa.name],
    },
    draft: false,
    type: ComplexCaseType.HEIR_TRANSFER,
  };
};
const translatedInverseMapping = (payload, values, excludeProperties) => {
  let mapping = {};
  if (excludeProperties) {
    mapping = {
      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[0] || ""
          : giuridicaIndirizzo.name.split(",")[0] || "",
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[1] || ""
          : giuridicaIndirizzo.name.split(",")[1] || "",

      "req.accountHolder.billing.cigCode": codiceCIG.name,
      "req.accountHolder.billing.cupCode": codiceCUP.name,
      "req.accountHolder.billing.paCode": codiceDestinatarioPA.name,
      "req.accountHolder.billing.pec": indirizzoPEC.name,
      "req.accountHolder.billing.sdiCode": codiceDestinatarioSDI.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.businessName": giuridicaRagioneSociale.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        bollettaComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        bollettaCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        bollettaProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        bollettaIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        bollettaIndirizzo.name,

      "req.accountHolder.contactsInfo.email": bollettaEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber": bollettaFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        bollettaCellulare.name,
      "req.accountHolder.contactsInfo.pec": bollettaPec.name,

      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderType": inQualitaDi.name,
      "req.accountHolder. holderOther": holderOther.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.iban": iban.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,

      "req.cadastre.administrativeUnit": datiCatastaliComuneAmministrativo.name,
      "req.cadastre.administrativeUnitProvince": datiCatastaliProvincia.name,
      "req.cadastre.building": datiCatastaliEdificio.name,
      "req.cadastre.cadastralLot": datiCatastaliParticella.name,
      "req.cadastre.cadastralMunicipality": datiCatastaliComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastaliCodiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastaliProvinciaCatastale.name,
      "req.cadastre.flat": datiCatastaliAppartamento.name,
      "req.cadastre.floor": datiCatastaliPiano.name,
      "req.cadastre.plot": datiCatastaliComuneFoglio.name,
      "req.cadastre.staircase": datiCatastaliScala.name,
      "req.cadastre.street": datiCatastaliIndirizzo.name,
      "req.cadastre.streetNumber": datiCatastaliNumeroCivico.name,
      "req.cadastre.subDivision": datiCatastaliSubalterno.name,
      "req.cadastre.type": tipo.name,
      "req.cadastre.urbanSection": datiCatastaliSezioneUrbana.name,

      "req.oldContract.declaration.acts.date": registeredDate.name,
      "req.oldContract.declaration.acts.note": ownerOtherInsert.name,
      "req.oldContract.declaration.acts.enabled": ownerStatus.name,
      "req.oldContract.declaration.acts.number": registeredNumber.name,
      "req.oldContract.declaration.acts.type": inQualitaDi.name,
      "req.oldContract.declaration.acts.from": dataPossessoImmobile.name,

      "req.oldContract.declaration.idricOutlet": presaIdrica.name,
      "req.oldContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.oldContract.usagetypeAreraClassification": case_2.name,
      "req.oldContract.domesticUseType": tipologiaUso.name,
      "req.oldContract.areraClassification":
        values[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO
          ? tipologiaUsoDomestica.name
          : tipologiaUsoNonDomestica.name,
      "req.oldContract.housingUnits": housingUnits.name,
      "req.oldContract.identityCardCode": estremiDelDocumento.name,
      "req.oldContract.integraContractCode": codiceContratto.name,
      "req.oldContract.invoiceNumber": numeroFattura.name,
      "req.oldContract.metreSerialNumber": matricolaContatoreCaseFirstStep.name,
      "req.oldContract.residentNumber": numeroResidenti.name,
      "req.oldContract.residentialUnits": residentialUnits.name,
      "req.oldContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.oldContract.lastReading.date": dataDecorrenza.name,
      "req.oldContract.subtypeAreraClassification": case_2.name,
      "req.oldContract.lastReading.value": letturaDecorrenza.name,

      "req.oldContract.finalReading.value": letturaFinale.name,

      "req.oldContract.notDomesticUseActivity": notDomesticUseActivity.name,
      "req.oldContract.notDomesticUseDetails": tipologiaUsoNonDomestica.name,
      "req.oldContract.notResidentialUnits": notResidentialUnits.name,

      "req.oldContract.selfReading": letturaPossessoImmobile.name,
      "req.oldContract.owner": tipologiaIntestatario.name,
    };
  } else {
    mapping = {
      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[0] || ""
          : giuridicaIndirizzo.name.split(",")[0] || "",
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[1] || ""
          : giuridicaIndirizzo.name.split(",")[1] || "",

      "req.accountHolder.billing.cigCode": codiceCIG.name,
      "req.accountHolder.billing.cupCode": codiceCUP.name,
      "req.accountHolder.billing.paCode": codiceDestinatarioPA.name,
      "req.accountHolder.billing.pec": indirizzoPEC.name,
      "req.accountHolder.billing.sdiCode": codiceDestinatarioSDI.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.businessName": giuridicaRagioneSociale.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        bollettaComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        bollettaCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        bollettaProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        bollettaIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        bollettaIndirizzo.name,

      "req.accountHolder.contactsInfo.email": bollettaEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber": bollettaFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        bollettaCellulare.name,
      "req.accountHolder.contactsInfo.pec": bollettaPec.name,

      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderType": inQualitaDi.name,
      "req.accountHolder. holderOther": holderOther.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.iban": iban.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,

      "req.cadastre.administrativeUnit": datiCatastaliComuneAmministrativo.name,
      "req.cadastre.administrativeUnitProvince": datiCatastaliProvincia.name,
      "req.cadastre.building": datiCatastaliEdificio.name,
      "req.cadastre.cadastralLot": datiCatastaliParticella.name,
      "req.cadastre.cadastralMunicipality": datiCatastaliComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastaliCodiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastaliProvinciaCatastale.name,
      "req.cadastre.flat": datiCatastaliAppartamento.name,
      "req.cadastre.floor": datiCatastaliPiano.name,
      "req.cadastre.plot": datiCatastaliComuneFoglio.name,
      "req.cadastre.staircase": datiCatastaliScala.name,
      "req.cadastre.street": datiCatastaliIndirizzo.name,
      "req.cadastre.streetNumber": datiCatastaliNumeroCivico.name,
      "req.cadastre.subDivision": datiCatastaliSubalterno.name,
      "req.cadastre.type": tipo.name,
      "req.cadastre.urbanSection": datiCatastaliSezioneUrbana.name,

      "req.oldContract.declaration.acts.date": registeredDate.name,
      "req.oldContract.declaration.acts.note": ownerOtherInsert.name,
      "req.oldContract.declaration.acts.enabled": ownerStatus.name,
      "req.oldContract.declaration.acts.number": registeredNumber.name,
      "req.oldContract.declaration.acts.type": inQualitaDi.name,
      "req.oldContract.declaration.acts.from": dataPossessoImmobile.name,

      "req.oldContract.declaration.idricOutlet": presaIdrica.name,
      "req.oldContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.oldContract.usagetypeAreraClassification": case_2.name,
      "req.oldContract.domesticUseType": tipologiaUso.name,
      "req.oldContract.areraClassification":
        values[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO
          ? tipologiaUsoDomestica.name
          : tipologiaUsoNonDomestica.name,
      "req.oldContract.housingUnits": housingUnits.name,
      "req.oldContract.identityCardCode": estremiDelDocumento.name,
      "req.oldContract.integraContractCode": codiceContratto.name,
      "req.oldContract.invoiceNumber": numeroFattura.name,
      "req.oldContract.metreSerialNumber": matricolaContatoreCaseFirstStep.name,
      "req.oldContract.residentNumber": numeroResidenti.name,
      "req.oldContract.residentialUnits": residentialUnits.name,
      "req.oldContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.oldContract.lastReading.date": dataDecorrenza.name,
      "req.oldContract.subtypeAreraClassification": case_2.name,
      "req.oldContract.lastReading.value": letturaDecorrenza.name,

      "req.oldContract.finalReading.value": letturaFinale.name,

      "req.oldContract.notDomesticUseActivity": notDomesticUseActivity.name,
      "req.oldContract.notDomesticUseDetails": tipologiaUsoNonDomestica.name,
      "req.oldContract.notResidentialUnits": notResidentialUnits.name,

      "req.oldContract.selfReading": letturaPossessoImmobile.name,
      "req.oldContract.owner": tipologiaIntestatario.name,
    };
  }
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
}
const translatedInverseMappingMortisCausa = (payload, values, excludeProperties) => {
  let mapping = {};
  if (excludeProperties) {
    mapping = {
      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[0] || ""
          : giuridicaIndirizzo.name.split(",")[0] || "",
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[1] || ""
          : giuridicaIndirizzo.name.split(",")[1] || "",

      "req.accountHolder.billing.cigCode": codiceCIG.name,
      "req.accountHolder.billing.cupCode": codiceCUP.name,
      "req.accountHolder.billing.paCode": codiceDestinatarioPA.name,
      "req.accountHolder.billing.pec": indirizzoPEC.name,
      "req.accountHolder.billing.sdiCode": codiceDestinatarioSDI.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.businessName": giuridicaRagioneSociale.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        bollettaComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        bollettaCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        bollettaProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        bollettaIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        bollettaIndirizzo.name,

      "req.accountHolder.contactsInfo.email": bollettaEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber": bollettaFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        bollettaCellulare.name,
      "req.accountHolder.contactsInfo.pec": bollettaPec.name,

      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderType": inQualitaDiMortisCausa.name,
      "req.accountHolder. holderOther": holderOther.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.iban": iban.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,

      "req.cadastre.administrativeUnit": datiCatastaliComuneAmministrativo.name,
      "req.cadastre.administrativeUnitProvince": datiCatastaliProvincia.name,
      "req.cadastre.building": datiCatastaliEdificio.name,
      "req.cadastre.cadastralLot": datiCatastaliParticella.name,
      "req.cadastre.cadastralMunicipality": datiCatastaliComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastaliCodiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastaliProvinciaCatastale.name,
      "req.cadastre.flat": datiCatastaliAppartamento.name,
      "req.cadastre.floor": datiCatastaliPiano.name,
      "req.cadastre.plot": datiCatastaliComuneFoglio.name,
      "req.cadastre.staircase": datiCatastaliScala.name,
      "req.cadastre.street": datiCatastaliIndirizzo.name,
      "req.cadastre.streetNumber": datiCatastaliNumeroCivico.name,
      "req.cadastre.subDivision": datiCatastaliSubalterno.name,
      "req.cadastre.type": tipo.name,
      "req.cadastre.urbanSection": datiCatastaliSezioneUrbana.name,

      "req.oldContract.declaration.acts.date": registeredDate.name,
      "req.oldContract.declaration.acts.note": ownerOtherInsert.name,
      "req.oldContract.declaration.acts.enabled": ownerStatus.name,
      "req.oldContract.declaration.acts.number": registeredNumber.name,
      "req.oldContract.declaration.acts.type": inQualitaDiMortisCausa.name,
      "req.oldContract.declaration.acts.from": dataPossessoImmobile.name,

      "req.oldContract.declaration.idricOutlet": presaIdrica.name,
      "req.oldContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.oldContract.usagetypeAreraClassification": case_2.name,
      "req.oldContract.domesticUseType": tipologiaUso.name,
      "req.oldContract.areraClassification":
        values[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO
          ? tipologiaUsoDomestica.name
          : tipologiaUsoNonDomestica.name,
      "req.oldContract.housingUnits": housingUnits.name,
      "req.oldContract.identityCardCode": estremiDelDocumento.name,
      "req.oldContract.integraContractCode": codiceContratto.name,
      "req.oldContract.invoiceNumber": numeroFattura.name,
      "req.oldContract.metreSerialNumber": matricolaContatoreCaseFirstStep.name,
      "req.oldContract.residentNumber": numeroResidenti.name,
      "req.oldContract.residentialUnits": residentialUnits.name,
      "req.oldContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.oldContract.lastReading.date": dataDecorrenza.name,
      "req.oldContract.subtypeAreraClassification": case_2.name,
      "req.oldContract.lastReading.value": letturaDecorrenza.name,

      "req.oldContract.finalReading.value": letturaFinale.name,

      "req.oldContract.notDomesticUseActivity": notDomesticUseActivity.name,
      "req.oldContract.notDomesticUseDetails": tipologiaUsoNonDomestica.name,
      "req.oldContract.notResidentialUnits": notResidentialUnits.name,

      "req.oldContract.selfReading": letturaPossessoImmobile.name,
      "req.oldContract.owner": tipologiaIntestatario.name,
      "req.oldContract.areraClassificationOther": areraClassificationOther.name,

      "req.erede.nome": ilSottoscrittoNomeMortisCausa.name,
      "req.erede.cognome": ilSottoscrittoCognomeMortisCausa.name,
      "req.erede.eredeUnico": soleHeirStatusMortisCausa.name,
      "req.erede.intestatario": ownerMortisCausa.name,
      "req.erede.dataDecesso": dateOwnerMortisCausa.name,
      "req.erede.tipologiaRelazione": degreeOfKinship.name,
      "req.erede.tipologiaRelazioneAltro": degreeOfKinshipOther.name,
      "req.erede.nucleoAgevolato": supplyContractMortisCausa.name,
    };
  } else {
    mapping = {
      "req.accountHolder.address.city":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaComuneResidenza.name
          : giuridicaSedeLegaleComune.name,
      "req.accountHolder.address.postalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCAP.name
          : giuridicaCAP.name,
      "req.accountHolder.address.province":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaProvincia.name
          : giuridicaProvincia.name,
      "req.accountHolder.address.street":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[0] || ""
          : giuridicaIndirizzo.name.split(",")[0] || "",
      "req.accountHolder.address.streetNumber":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaVia.name.split(",")[1] || ""
          : giuridicaIndirizzo.name.split(",")[1] || "",

      "req.accountHolder.billing.cigCode": codiceCIG.name,
      "req.accountHolder.billing.cupCode": codiceCUP.name,
      "req.accountHolder.billing.paCode": codiceDestinatarioPA.name,
      "req.accountHolder.billing.pec": indirizzoPEC.name,
      "req.accountHolder.billing.sdiCode": codiceDestinatarioSDI.name,
      "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

      "req.accountHolder.birthDate": fisicaDataNascita.name,
      "req.accountHolder.birthPlace": fisicaNatoA.name,
      "req.accountHolder.businessName": giuridicaRagioneSociale.name,

      "req.accountHolder.contactsInfo.addressRecapito.city":
        bollettaComune.name,
      "req.accountHolder.contactsInfo.addressRecapito.name":
        bollettaNomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.surname":
        bollettaCognomePresso.name,
      "req.accountHolder.contactsInfo.addressRecapito.postalCode":
        bollettaCap.name,
      "req.accountHolder.contactsInfo.addressRecapito.province":
        bollettaProvincia.name,
      "req.accountHolder.contactsInfo.addressRecapito.street":
        bollettaIndirizzo.name,
      "req.accountHolder.contactsInfo.addressRecapito.streetNumber":
        bollettaIndirizzo.name,

      "req.accountHolder.contactsInfo.email": bollettaEmail.name,
      "req.accountHolder.contactsInfo.landlinePhoneNumber": bollettaFisso.name,
      "req.accountHolder.contactsInfo.mobilePhoneNumber":
        bollettaCellulare.name,
      "req.accountHolder.contactsInfo.pec": bollettaPec.name,

      "req.accountHolder.fiscalCode":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCodiceFiscale.name
          : giuridicaCodiceFiscale.name,
      "req.accountHolder.holderType": inQualitaDiMortisCausa.name,
      "req.accountHolder. holderOther": holderOther.name,
      "req.accountHolder.name":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaNome.name
          : giuridicaNome.name,
      "req.accountHolder.personType": tipoIntestatario.name,
      "req.accountHolder.sex": fisicaSesso.name,
      "req.accountHolder.surname":
        values[tipoIntestatario.name] === PersonType.NATURAL
          ? fisicaCognome.name
          : giuridicaCognome.name,
      "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,

      "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
      "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
      "req.bankDomiciliation.bankBranch": agencia.name,
      "req.bankDomiciliation.bankName": bankName.name,
      "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
      "req.bankDomiciliation.iban": iban.name,
      "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
      "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
      "req.bankDomiciliation.owner": cognomeNomeDelConto.name,

      "req.cadastre.administrativeUnit": datiCatastaliComuneAmministrativo.name,
      "req.cadastre.administrativeUnitProvince": datiCatastaliProvincia.name,
      "req.cadastre.building": datiCatastaliEdificio.name,
      "req.cadastre.cadastralLot": datiCatastaliParticella.name,
      "req.cadastre.cadastralMunicipality": datiCatastaliComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityCode":
        datiCatastaliCodiceComuneCatastale.name,
      "req.cadastre.cadastralMunicipalityProvince":
        datiCatastaliProvinciaCatastale.name,
      "req.cadastre.flat": datiCatastaliAppartamento.name,
      "req.cadastre.floor": datiCatastaliPiano.name,
      "req.cadastre.plot": datiCatastaliComuneFoglio.name,
      "req.cadastre.staircase": datiCatastaliScala.name,
      "req.cadastre.street": datiCatastaliIndirizzo.name,
      "req.cadastre.streetNumber": datiCatastaliNumeroCivico.name,
      "req.cadastre.subDivision": datiCatastaliSubalterno.name,
      "req.cadastre.type": tipo.name,
      "req.cadastre.urbanSection": datiCatastaliSezioneUrbana.name,

      "req.oldContract.declaration.acts.date": registeredDate.name,
      "req.oldContract.declaration.acts.note": ownerOtherInsert.name,
      "req.oldContract.declaration.acts.enabled": ownerStatus.name,
      "req.oldContract.declaration.acts.number": registeredNumber.name,
      "req.oldContract.declaration.acts.type": inQualitaDiMortisCausa.name,
      "req.oldContract.declaration.acts.from": dataPossessoImmobile.name,

      "req.oldContract.declaration.idricOutlet": presaIdrica.name,
      "req.oldContract.declaration.undersigned": ilSottoscrittoNome.name,
      "req.oldContract.usagetypeAreraClassification": case_2.name,
      "req.oldContract.domesticUseType": tipologiaUso.name,
      "req.oldContract.areraClassification":
        values[tipologiaUso.name] === TipologiaUsoFornitura.DOMESTICO
          ? tipologiaUsoDomestica.name
          : tipologiaUsoNonDomestica.name,
      "req.oldContract.housingUnits": housingUnits.name,
      "req.oldContract.identityCardCode": estremiDelDocumento.name,
      "req.oldContract.integraContractCode": codiceContratto.name,
      "req.oldContract.invoiceNumber": numeroFattura.name,
      "req.oldContract.metreSerialNumber": matricolaContatoreCaseFirstStep.name,
      "req.oldContract.residentNumber": numeroResidenti.name,
      "req.oldContract.residentialUnits": residentialUnits.name,
      "req.oldContract.onlineBill.enabled": bollettaOnlineAttiva.name,

      "req.oldContract.lastReading.date": dataDecorrenza.name,
      "req.oldContract.subtypeAreraClassification": case_2.name,
      "req.oldContract.lastReading.value": letturaDecorrenza.name,

      "req.oldContract.finalReading.value": letturaFinale.name,

      "req.oldContract.notDomesticUseActivity": notDomesticUseActivity.name,
      "req.oldContract.notDomesticUseDetails": tipologiaUsoNonDomestica.name,
      "req.oldContract.notResidentialUnits": notResidentialUnits.name,
      "req.oldContract.areraClassificationOther": areraClassificationOther.name,

      "req.oldContract.selfReading": letturaPossessoImmobile.name,
      "req.oldContract.owner": tipologiaIntestatario.name,
      "req.erede.nome": ilSottoscrittoNomeMortisCausa.name,
      "req.erede.cognome": ilSottoscrittoCognomeMortisCausa.name,
      "req.erede.eredeUnico": soleHeirStatusMortisCausa.name,
      "req.erede.intestatario": ownerMortisCausa.name,
      "req.erede.dataDecesso": dateOwnerMortisCausa.name,
      "req.erede.tipologiaRelazione": degreeOfKinship.name,
      "req.erede.tipologiaRelazioneAltro": degreeOfKinshipOther.name,
      "req.erede.nucleoAgevolato": supplyContractMortisCausa.name,
    };
  }

  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};
const getTrackingEventKo = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Voltura, "step": "invio_richiesta", "esito": "KO" }) };
const getTrackingEvent = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Voltura, "step": "invio_richiesta", "esito": "OK" }) };
const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel, activeStep) => {
  sign = signDigital;
  const layout = getLayout(privacyLink, privacyCtaLabel);
  let excludeStepsCopy = [];
  if(excludeSteps !== undefined){
    excludeStepsCopy = [...excludeSteps];
  }
  let validation = getValidationSchema(buttonMatricolaContatoreCase);
  let modelExcludeStep={...model};
  let layoutExcludeSteps = [...layout];
  let validationCopy = [...validation];
  let initialValuesExcludeSteps = {...initialValues};  
  if(volturaMortisCausa.volturaMortisCausaCheckbox && excludeSteps !== undefined){
    if(!excludeSteps.includes(2)){
      excludeStepsCopy.push(2);
    }
    if(!excludeSteps.includes(4)){
      excludeStepsCopy.push(4);
    }
    if(!excludeSteps.includes(6)){
      excludeStepsCopy.push(6);
    }
    if(!excludeSteps.includes(5) && excludeStepsCopy.includes(5)){
      excludeStepsCopy.splice(excludeStepsCopy.indexOf(5),1);
    }
    layoutExcludeSteps[7].chapter=true;
  }
  else if(!volturaMortisCausa.volturaMortisCausaCheckbox && excludeSteps !== undefined){
    if(!excludeSteps.includes(2) && excludeStepsCopy.includes(2)){
      excludeStepsCopy.splice(excludeStepsCopy.indexOf(2),1);
    }
    if(!excludeSteps.includes(4) && excludeStepsCopy.includes(4)){
      excludeStepsCopy.splice(excludeStepsCopy.indexOf(4),1);
    }
    if(!excludeSteps.includes(6) && excludeStepsCopy.includes(6)){
      excludeStepsCopy.splice(excludeStepsCopy.indexOf(6),1);
    }
    if(!excludeSteps.includes(5)){
      excludeStepsCopy.push(5);
    }
    layoutExcludeSteps[7].chapter=false;
  }
  if(activeStep === 0){
    layoutExcludeSteps[7].chapter=false;
  }
  if (excludeStepsCopy && activeStep > 0) {
    const stepsExcluded = excludeStepsCopy;
    let deletedLayout = removeRequiredStep(stepsExcluded, layoutExcludeSteps);
    const { ...formFieldCopy }  = {...model};
    validationCopy = removeDeletedLayoutFields(
      deletedLayout,
      {...formFieldCopy},
      initialValuesExcludeSteps,
      validationCopy,
      true,
    );
    modelExcludeStep = { ...model, ...formFieldCopy };
  }
  return {
    model : modelExcludeStep,
    validationSchema: validationCopy,
    initialValues : initialValuesExcludeSteps,
    layout : layoutExcludeSteps,
    formDetails: getFormDetails(sign),
    trackingEventKo: getTrackingEventKo(),
    trackingEvent: getTrackingEvent(),
    translatedMapping : !volturaMortisCausa.volturaMortisCausaCheckbox ? translatedMapping : translatedMappingMortisCausa,
    translatedInverseMapping : !volturaMortisCausa.volturaMortisCausaCheckbox ? translatedInverseMapping : translatedInverseMappingMortisCausa,
    mutation,
  };
};

export default main;

